import * as _ from "lodash-es";
import moment, { Moment } from "moment-timezone";
import { ChangeEvent, Component } from "react";
import { ColorResult, CompactPicker } from "react-color";
import BackorderBehaviorEnum from "../../../../models/BackorderBehaviorEnum";
import BackorderModalVisibilityEnum from "../../../../models/BackorderModalVisibilityEnum";
import ContextEnum from "../../../../models/ContextEnum";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../../models/DTO/IGetCatalogsDTO";
import IGetPriceGroupsDTO from "../../../../models/DTO/IGetPriceGroupsDTO";
import IGetServiceLevelsDTO from "../../../../models/DTO/IGetServiceLevelsDTO";
import IOnGetCatalogsDTO from "../../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetPriceGroupsDTO from "../../../../models/DTO/IOnGetPriceGroupsDTO";
import IOnGetServiceLevelsDTO from "../../../../models/DTO/IOnGetServiceLevelsDTO";
import IOnUpdateSupplierDTO from "../../../../models/DTO/IOnUpdateSupplierDTO";
import IOnUpdateSupplierSettingsDTO from "../../../../models/DTO/IOnUpdateSupplierSettingsDTO";
import IUpdateSupplierSettingsDTO from "../../../../models/DTO/IUpdateSupplierSettingsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import FileUploadResourceTypeEnum from "../../../../models/FileUploadResourceTypeEnum";
import ICatalog from "../../../../models/ICatalog";
import INotification from "../../../../models/INotification";
import IOrder from "../../../../models/IOrder";
import IPrice_Group from "../../../../models/IPrice_Group";
import IServiceLevel from "../../../../models/IServiceLevel";
import ISupplierModel from "../../../../models/ISupplierModel";
import ISupplierSettings from "../../../../models/ISupplierSettings";
import IThemeVariables from "../../../../models/IThemeVariables";
import IUserUI from "../../../../models/IUserUI";
import NotificationLevelEnum from "../../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../../models/NotificationPositionEnum";
import OrderSourceEnum from "../../../../models/OrderSourceEnum";
import OrderStatesEnum from "../../../../models/OrderStatesEnum";
import PaymentServiceTypeEnum from "../../../../models/PaymentServiceTypeEnum";
import PriceUpchargeTypeEnum from "../../../../models/PriceUpchargeTypeEnum";
import OrderEntryService from "../../../../services/OrderEntryService";
import SystemConst from "../../../../services/SystemConst";
import UIService from "../../../../services/UIService";
import { LoginMessage } from "../../../dashboard/LoginMessage/LoginMessage";
import ChevronToggle from "../../../shared/ChevronToggle/ChevronToggle";
import OrderProgressTracker from "../../../shared/OrderProgressTracker/OrderProgressTracker";
import { OwBackToTop } from "../../../shared/OwBackToTop/OwBackToTop";
import OwButton from "../../../shared/OwButton/OwButton";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import ChipSizeEnum from "../../../shared/OwChips/ChipSizeEnum";
import OwChips from "../../../shared/OwChips/OwChips";
import OwDateRange from "../../../shared/OwDateRange/OwDateRange";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwS3Uploader from "../../../shared/OwS3Uploader/OwS3Uploader";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import OwToggle from "../../../shared/OwToggle/OwToggle";
import OwWeightSelector from "../../../shared/OwWeightSelector/OwWeightSelector";
import { ApiKey } from "../ApiKey/ApiKey";
import { BrandedLoginSidebar } from "../BrandedLoginSidebar/BrandedLoginSidebar";
import HolidaysSidebar from "../HolidaysSidebar/HolidaysSidebar";
import OrderCategoriesSidebar from "../OrderCategoriesSidebar/OrderCategoriesSidebar";
import OrderWorkflowConfigurator from "../OrderWorkflowConfigurator/OrderWorkflowConfigurator";
import OwThemeConfigurator from "../OwThemeConfigurator/OwThemeConfigurator";
import PendingChangesBar from "../PendingChangesBar/PendingChangesBar";
import ServiceLevelsSidebar from "../ServiceLevelsSidebar/ServiceLevelsSidebar";
import { SettingsRow } from "../SettingsRow/SettingsRow";
import "./SupplierProfileOptions.scss";
import ShippingZoneWeightTiersSidebar from "../ShippingWeightTiersSidebar/ShippingZoneWeightTiersSidebar";
import ShippingZonesSidebar from "../ShippingZonesSidebar/ShippingZonesSidebar";
import OwTextArea from "../../../shared/OwTextArea/OwTextArea";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";
import { Dock } from "react-dock";
import { WorkflowSidebar } from "../WorkflowSidebar/WorkflowSidebar";
import { DocLogo } from "../../../shared/DocLogo/DocLogo";
import { WhiteLabelLogo } from "../../../shared/WhiteLabelLogo/WhiteLabelLogo";
import ProductGroupComponentEnum from "../../../../models/ProductGroupComponentEnum";
import { Socket } from "socket.io-client";
import { EditScreenOptions } from "../EditScreenOptions/EditScreenOptions";
import { EditShippingCarriersSidebar } from "../EditShippingCarriersSidebar/EditShippingCarriersSidebar";
import { StateByStateTaxSidebar } from "../StateByStateTaxSidebar/StateByStateTaxSidebar";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import { NavigateFunction } from "react-router";
import { ControlBar } from "@components/shared/ControlBar/ControlBar";
import { OwIconTooltip } from "@components/shared/OwIconTooltip/OwIconTooltip";
import ISalesTaxConfig from "@models/ISalesTaxConfig";
import { OrderTotalTiersSidebar } from "../OrderTotalTiersSidebar/OrderTotalTiersSidebar";
import EcommerceListView from "@components/order_entry/EcommerceListView/EcommerceListView";
import ICatalog_Item from "@models/ICatalog_Item";
import WhatsThis from "@components/shared/WhatsThis/WhatsThis";

type Props = {
    userModel: IUserUI;
    socket: Socket;
    saveFn: (data: any, hasOrderProgressStateChanges?: boolean) => void;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
    showHiddenFeatures: boolean;
    navigate: NavigateFunction;
};

type State = {
    supplierModel: ISupplierModel;
    numPendingChanges: number;
    activeSaveBtn: boolean;
    tokenEmailsList: string[];
    token_email: string;
    hasSettingsChange: boolean;
    hasModelChange: boolean;
    fakeOrder: Partial<IOrder>;
    showOrderWorkflowConfig: boolean;
    hasOrderProgressStateChanges?: boolean;
    updateSupplierState: boolean;
    previewTheme: boolean;
    catalogs: ICatalog[];
    priceGroups: IPrice_Group[];
    retrievedCatalogs: boolean;
    isDockVisible: boolean;
    dockComponent: any;
    dockHeight: number;
    serviceLevels: IServiceLevel[];
    dockCss: { bg: string; color: string };
    supplierSettings: ISupplierSettings;
    useV2SettingsSaveFn: boolean;
};

class SupplierProfileOptions extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        let tokenEmailsList: string[] = [];

        if (
            this.props.supplierModel.settings &&
            !_.isString(this.props.supplierModel.settings) &&
            this.props.supplierModel.settings.token_emails
        ) {
            tokenEmailsList = this.props.supplierModel.settings.token_emails;
        }

        this.state = {
            numPendingChanges: 0,
            supplierModel: this.props.supplierModel,
            activeSaveBtn: false,
            tokenEmailsList,
            token_email: "",
            hasSettingsChange: false,
            hasModelChange: false,
            fakeOrder: { order_source_id: OrderSourceEnum.ORDERWERKS, order_state_id: OrderStatesEnum.PRELIMINARY } as Partial<IOrder>,
            showOrderWorkflowConfig: false,
            hasOrderProgressStateChanges: false,
            updateSupplierState: false,
            previewTheme: false,
            catalogs: [],
            priceGroups: [],
            retrievedCatalogs: false,
            isDockVisible: false,
            dockComponent: null,
            dockHeight: 0.45,
            serviceLevels: [],
            dockCss: UIService.getDockCss(),
            supplierSettings: this.props.supplierModel.settings,
            useV2SettingsSaveFn: false,
        };

        document.title = `Orderwerks >> Settings`;
    }

    onUpdateSupplierSettings = () => {
        const notification: INotification = {
            message: "successfully_updated_supplier_settings",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        this.props.notifyFn(null, notification);

        this.setState({
            numPendingChanges: 0,
            hasSettingsChange: false,
            activeSaveBtn: false,
        });
    };

    onUpdateSupplier = () => {
        this.setState(
            {
                numPendingChanges: 0,
                hasModelChange: false,
                activeSaveBtn: false,
                hasOrderProgressStateChanges: false,
            },
            () => {
                const notification: INotification = {
                    title: "successfully_updated_settings",
                    level: NotificationLevelEnum.success,
                    position: NotificationPositionEnum.bc,
                };

                this.props.notifyFn(null, notification);
            }
        );
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        this.setState(
            {
                catalogs: data.catalogs,
            },
            () => {
                if (this.state.supplierModel.default_order_catalog_id) {
                    const catalogModel = this.state.catalogs.find(
                        (catalog) => catalog.id === this.state.supplierModel.default_order_catalog_id
                    );

                    if (catalogModel) {
                        this.getPriceGroups(catalogModel.guid);
                    }
                }
            }
        );
    };

    onGetPriceGroups = (data: IOnGetPriceGroupsDTO) => {
        this.setState({
            priceGroups: data.priceGroups,
        });
    };

    onGetServiceLevels = (data: IOnGetServiceLevelsDTO) => {
        this.setState({
            serviceLevels: data.serviceLevels,
        });
    };

    notify = () => {
        this.setState({
            activeSaveBtn: false,
        });
    };

    sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.SupplierOnUpdateSupplier, fn: this.onUpdateSupplier },
        { endpoint: EndpointsEnum.SupplierOnUpdateSupplierSettings, fn: this.onUpdateSupplierSettings },
        { endpoint: EndpointsEnum.CatalogsOnGetCatalogs, fn: this.onGetCatalogs },
        { endpoint: EndpointsEnum.CatalogsOnGetPriceGroups, fn: this.onGetPriceGroups },
        { endpoint: EndpointsEnum.SuppliersOnGetServiceLevels, fn: this.onGetServiceLevels },
        { endpoint: EndpointsEnum.Notify, fn: this.notify },
    ];

    componentDidMount(): void {
        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        if (this.props.supplierModel.has_service_levels) {
            this.getServiceLevels();
        }
    }

    componentWillUnmount(): void {
        for (const socket of this.sockets) {
            this.props.socket.off(socket.endpoint, socket.fn);
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (this.state.updateSupplierState) {
            if (this.state.previewTheme) {
                console.error("Need to fix themePreview$");
                // UIService.themePreview$().next(true);
            }

            this.setState({
                previewTheme: false,
                updateSupplierState: false,
                supplierModel: this.props.supplierModel,
            });
        }

        if (!this.state.retrievedCatalogs) {
            this.getCatalogs();
        }
    }

    getServiceLevels = () => {
        const payload: IGetServiceLevelsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SuppliersGetServiceLevels, payload);
    };

    handleBolLDetailChange = (e: any, prop: string) => {
        const state: any = {
            supplierModel: this.state.supplierModel,
            hasModelChange: true,
            numPendingChanges: this.state.numPendingChanges + 1,
        };

        const name = e.target.name;
        const value = e.target.value;

        // @ts-expect-error
        state.supplierModel.bill_of_lading_details[name] = value;

        this.setState(state);
    };

    handleSupplierChange = (e: any, subProp?: string) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            supplierModel: this.state.supplierModel,
            hasModelChange: true,
            numPendingChanges: this.state.numPendingChanges + 1,
        };

        if (name === "order_progress_states") {
            state.hasOrderProgressStateChanges = true;
        }

        if (name === "has_bill_of_lading") {
            // Setting a JSON Default value if not present.
            if (_.isNil(state.supplierModel.bill_of_lading_details)) {
                state.supplierModel.bill_of_lading_details = {
                    shipperLegalCopy: "",
                    receiverLegalCopy: "",
                };
            }
        }

        if (_.isNil(state.supplierModel[name])) {
            state.supplierModel[name] = {};
        }

        if (subProp) {
            state.supplierModel[name][subProp] = value;
        } else {
            state.supplierModel[name] = value;
        }

        this.setState(state, () => {
            if (name === "default_new_account_catalog_id") {
                const catalogModel = this.state.catalogs.find(
                    (catalog) => catalog.id === Number(this.state.supplierModel.default_new_account_catalog_id)
                );

                if (catalogModel) {
                    this.getPriceGroups(catalogModel.guid);
                }
            }

            if (name === "default_order_catalog_id") {
                const catalogModel = this.state.catalogs.find(
                    (catalog) => catalog.id === Number(this.state.supplierModel.default_order_catalog_id)
                );

                if (catalogModel) {
                    this.getPriceGroups(catalogModel.guid);
                }
            }
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state = {
            [name]: value,
        };

        // @ts-expect-error
        this.setState(state);
    };

    save = () => {
        this.setState(
            {
                activeSaveBtn: true,
            },
            () => {
                this.props.saveFn(this.state.supplierModel, this.state.hasOrderProgressStateChanges);

                if (this.state.hasSettingsChange) {
                    if (this.state.useV2SettingsSaveFn) {
                        this.updateSupplierSettingsV2();
                    } else {
                        this.updateSupplierSettings();
                    }
                }
            }
        );
    };

    clearLoginMessage = () => {
        const state = {
            supplierModel: this.state.supplierModel,
        };

        // @ts-expect-error
        state.supplierModel.login_message_detail = null;

        this.setState(state);
    };

    getPriceGroups = (catalogGuid: string) => {
        if (catalogGuid) {
            const payload: IGetPriceGroupsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                catalogGuid,
            };

            this.props.socket.emit(EndpointsEnum.CatalogsGetPriceGroups, payload);
        }
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            callMeta: {
                view: "SupplierProfileOptions",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);

        this.setState({
            retrievedCatalogs: true,
        });
    };

    handleStartDateChange = (selectedDate: Moment | null) => {
        const state: any = {
            supplierModel: this.state.supplierModel,
        };

        if (!state.supplierModel.login_message_detail) {
            state.supplierModel.login_message_detail = {};
        }

        if (selectedDate) {
            state.supplierModel.login_message_detail.begins_at = selectedDate.format("YYYY-MM-DD 00:00:00");
        }

        this.setState(state);
    };

    handleEndDateChange = (selectedDate: Moment | null) => {
        const state: any = {
            supplierModel: this.state.supplierModel,
        };

        if (!state.supplierModel.login_message_detail) {
            state.supplierModel.login_message_detail = {};
        }

        if (selectedDate) {
            state.supplierModel.login_message_detail.expires_at = selectedDate.format("YYYY-MM-DD 23:59:59");
        }

        this.setState(state);
    };

    handleColorChange = (color: ColorResult) => {
        const state: any = {
            supplierModel: this.state.supplierModel,
        };

        if (!state.supplierModel.login_message_detail) {
            state.supplierModel.login_message_detail = {};
        }

        state.supplierModel.login_message_detail.color = color.hex;

        this.setState(state);
    };

    updateSupplierThemeSettings = () => {
        const existingSettings = !_.isString(this.props.supplierModel.settings) ? this.props.supplierModel.settings : { theme: "DARK" };

        const payload: IUpdateSupplierSettingsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            settings: {
                ...existingSettings,
                // @ts-expect-error
                theme: this.state.supplierModel.settings.theme,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierSettings, payload);

        this.setState({
            updateSupplierState: true,
            previewTheme: true,
        });
    };

    updateSupplierSettingsV2 = () => {
        const payload: IUpdateSupplierSettingsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            settings: {
                ...this.state.supplierSettings,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierSettings, payload);

        this.setState({
            updateSupplierState: true,
            activeSaveBtn: true,
            useV2SettingsSaveFn: false,
        });
    };

    updateSupplierSettings = () => {
        const existingSettings = !_.isString(this.props.supplierModel.settings) ? this.props.supplierModel.settings : { theme: "DARK" };

        const payload: IUpdateSupplierSettingsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            settings: {
                ...existingSettings,
                token_emails: this.state.tokenEmailsList,
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierSettings, payload);

        this.setState({
            updateSupplierState: true,
        });
    };

    updatedChips = (chips: string | string[]) => {
        if (_.isString(chips)) {
            return;
        }

        this.setState({
            hasSettingsChange: true,
            tokenEmailsList: chips,
        });
    };

    addTokenEmail = (e: any) => {
        const tokenEmailsList = this.state.tokenEmailsList;

        tokenEmailsList.push(this.state.token_email);

        this.setState({
            tokenEmailsList,
            token_email: "",
            hasSettingsChange: true,
            numPendingChanges: this.state.numPendingChanges + 1,
        });
    };

    coopAdvertisment = () => {
        let coopAdvertisementRow: any = null;

        if (this.props.supplierModel && this.props.supplierModel.has_coop_advertisement) {
            const coopPercent = _.get(this.props.supplierModel, "Coop_Advertisement.percent", 0);

            coopAdvertisementRow = (
                <tr>
                    <td className={"text-end w-20"}>
                        <OwLabel title={"coop_advertisement_rate"} className={"d-inline-flex me-2"} />
                    </td>
                    <td className={"w-70"}>
                        <div className={"d-flex "}>
                            <div className={"me-1"}>{coopPercent}%</div>
                        </div>
                    </td>
                </tr>
            );
        }

        return coopAdvertisementRow;
    };

    tokenEmails = () => {
        const tokenEmailsList = this.state.tokenEmailsList;

        const tokenEmailsComponent = (
            <div>
                <div className={"row mb-2"}>
                    <div className={"col-3"}>
                        <OwInputWrapper fn={this.handleChange} name={"token_email"} value={this.state.token_email} />
                    </div>
                    <div className={"col"}>
                        <OwButton title={"add"} fn={this.addTokenEmail} />
                    </div>
                </div>

                <OwChips
                    chips={tokenEmailsList}
                    updatedFn={this.updatedChips}
                    context={ContextEnum.PRIMARY}
                    isStacked={true}
                    chipSize={ChipSizeEnum.XS}
                />
            </div>
        );

        return (
            <SettingsRow
                title={"token_emails"}
                detail={"help_text_token_emails"}
                name={"has_price_adjustments"}
                component={tokenEmailsComponent}
            />
        );
    };

    loginNotification = (tableClass: string) => {
        const iconOptions = [
            "fad fa-box",
            "fad fa-turkey",
            "fad fa-tree-christmas",
            "fad fa-glass-cheers",
            "fad fa-egg",
            "fad fa-landmark",
            "fad fa-monument",
            "fad fa-user-tie",
            "fad fa-lights-holiday",
            "fad fa-candy-corn",
            "fad fa-ornament",
            "fad fa-dreidel",
            "fad fa-candy-cane",
            "fad fa-bells",
            "fad fa-wreath",
            "fad fa-ghost",
            "fad fa-birthday-cake",
            "fad fa-door-closed",
            "far fa-hidden",
        ];

        const iconSelectionOptions = iconOptions.map((iconOption: string, index: number) => {
            return (
                <div className={"d-inline-flex align-items-center me-4 w-4r mb-4"} key={index}>
                    <label className={"pointer"}>
                        <OwInputWrapper
                            type={"radio"}
                            checked={
                                this.state.supplierModel.login_message_detail
                                    ? this.state.supplierModel.login_message_detail.icon === iconOption
                                    : false
                            }
                            value={iconOption}
                            name={"login_message_detail"}
                            fn={(e: any) => {
                                this.handleSupplierChange(e, "icon");
                            }}
                        />
                        <i className={"ms-2 " + iconOption} />
                    </label>
                </div>
            );
        });

        let selectedLoginMessageStartDate;
        let selectedLoginMessageEndDate;

        let selectedColor = "#FFFFFF";
        let loginTitle;
        let loginDetail;
        let loginIcon;

        if (_.isNil(this.props.supplierModel)) {
            return null;
        } else {
            if (this.state.supplierModel.login_message_detail) {
                selectedLoginMessageStartDate = moment(this.state.supplierModel.login_message_detail.begins_at).toDate();
                selectedLoginMessageEndDate = moment(this.state.supplierModel.login_message_detail.expires_at).toDate();
                selectedColor = this.state.supplierModel.login_message_detail.color;
                loginTitle = this.state.supplierModel.login_message_detail.title;
                loginDetail = this.state.supplierModel.login_message_detail.detail;
                loginIcon = this.state.supplierModel.login_message_detail.icon;
            }
        }

        return (
            <tr>
                <td className={"text-end"}>
                    <div>
                        <OwLabel title={"login_message"} className={"d-inline-flex me-2"} />
                    </div>
                    <div className={"mt-2"}>
                        <OwLabel title={"help_text_login_message"} className={"text-muted mt-4"} />
                    </div>
                </td>
                <td>
                    <div>
                        <p>Preview:</p>
                        <LoginMessage loginMessageDetail={this.state.supplierModel.login_message_detail} showPreviewBox={true} />
                        <div className={"mt-2 mb-2"}>
                            <OwButton className={"btn-danger"} leftIconClass={"fa fa-eraser"} title={"clear"} fn={this.clearLoginMessage} />
                        </div>
                        <div>
                            <table className={tableClass + " col-12"} style={{ maxWidth: "initial" }}>
                                <tbody>
                                    <tr>
                                        <td className={"w-10 col-3"}>
                                            <OwLabel title={"title"} />:
                                        </td>
                                        <td className={"col-9"}>
                                            <div className={"col-6"}>
                                                <OwInputWrapper
                                                    value={loginTitle}
                                                    name={"login_message_detail"}
                                                    fn={(e: any) => {
                                                        this.handleSupplierChange(e, "title");
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <OwLabel title={"detail"} />:
                                        </td>
                                        <td>
                                            <div className={"col-6"}>
                                                <OwInputWrapper
                                                    name={"login_message_detail"}
                                                    value={loginDetail}
                                                    fn={(e: any) => {
                                                        this.handleSupplierChange(e, "detail");
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <OwLabel title={"icon"} />:
                                        </td>
                                        <td>
                                            <div className={"col-12"}>{iconSelectionOptions}</div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <OwLabel title={"color"} />:
                                        </td>
                                        <td>
                                            <div className={"col-6"}>
                                                {/*<OwInputWrapper name={"login_message_detail.color"}*/}
                                                {/*         fn={this.handleSupplierChange}/>*/}
                                                <CompactPicker onChange={this.handleColorChange} />
                                            </div>
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <OwLabel title={"timeframe"} />:
                                        </td>
                                        <td>
                                            <div className={"col-6"}>
                                                <OwDateRange
                                                    startFn={this.handleStartDateChange}
                                                    startDateSelected={selectedLoginMessageStartDate}
                                                    endFn={this.handleEndDateChange}
                                                    endDateSelected={selectedLoginMessageEndDate}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </td>
            </tr>
        );
    };

    leadTime = () => {
        if (!this.props.supplierModel.has_lead_times) {
            return null;
        } else {
            const lead_time_options = [
                { value: "hours", title: "Hour(s)" },
                { value: "days", title: "Day(s)" },
                { value: "months", title: "Month(s)" },
            ];

            const leadTimeComponent = (
                <div className={"d-flex "}>
                    <div className={"me-1"}>
                        <OwInputWrapper
                            className={"form-control-sm text-end"}
                            name={"shipping_lead_time"}
                            value={this.state.supplierModel.shipping_lead_time}
                            fn={this.handleSupplierChange}
                            disabled={this.state.supplierModel.has_service_levels}
                        />
                    </div>
                    <div className={""}>
                        <OwSelectOption
                            showBlankFirst={true}
                            selectedOption={this.state.supplierModel}
                            selectedOptionProp={"profile_lead_time_type"}
                            options={lead_time_options}
                            valueProp={"value"}
                            titleProp={"title"}
                            fn={this.handleSupplierChange}
                            name={"profile_lead_time_type"}
                            isDisabled={this.state.supplierModel.has_service_levels}
                        />
                    </div>
                </div>
            );

            return (
                <SettingsRow title={"lead_time"} detail={"help_text_lead_time"} name={"shipping_lead_time"} component={leadTimeComponent} />
            );
        }
    };

    productGroupComponent = () => {
        const productGroupComponentOptions = [
            { value: ProductGroupComponentEnum.STANDARD, title: "Standard" },
            { value: ProductGroupComponentEnum.MODAL, title: "Modal" },
        ];

        const componentSelect = (
            <div className={"d-flex "}>
                <div className={""}>
                    <OwSelectOption
                        selectedOption={this.props.supplierModel}
                        selectedOptionProp={"group_component"}
                        options={productGroupComponentOptions}
                        valueProp={"value"}
                        titleProp={"title"}
                        fn={this.handleSupplierChange}
                        name={"group_component"}
                    />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"product_group_component"}
                detail={"help_text_product_group_component"}
                name={"group_component"}
                component={componentSelect}
            />
        );
    };

    getVendorNameOverride = () => {
        const vendorNameOverrideOptions = [
            { value: "vendor", title: "Vendor" },
            { value: "retailer", title: "Retailer" },
            { value: "customer", title: "Customer" },
            { value: "dealer", title: "Dealer" },
            { value: "reseller", title: "Reseller" },
        ];

        const nameOverrideComponent = (
            <div className={"d-flex "}>
                <div className={""}>
                    <OwSelectOption
                        selectedOption={this.props.supplierModel}
                        selectedOptionProp={"vendor_name_override"}
                        options={vendorNameOverrideOptions}
                        valueProp={"value"}
                        titleProp={"title"}
                        fn={this.handleSupplierChange}
                        name={"vendor_name_override"}
                    />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"account_name_override"}
                detail={"help_text_vendor_name_override"}
                name={"vendor_name_override"}
                component={nameOverrideComponent}
            />
        );
    };

    getNotifyMinQty = () => {
        return (
            <SettingsRow
                title={"notify_min_qty"}
                detail={"help_text_notify_min_qty"}
                name={"notify_on_min_qty"}
                isActive={this.state.supplierModel.notify_on_min_qty}
                showDisableConfirm={false}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hideWhenMinQtyOnHand = () => {
        return (
            <SettingsRow
                title={"hide_when_min_qty_on_hand"}
                detail={"help_text_hide_when_min_qty_on_hand"}
                name={"hide_when_min_qty_on_hand"}
                isActive={this.state.supplierModel.hide_when_min_qty_on_hand}
                showDisableConfirm={false}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    sendVendorEmails = () => {
        return (
            <SettingsRow
                title={"send_account_emails"}
                detail={"help_text_send_account_emails"}
                name={"send_vendor_emails"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.send_vendor_emails}
                showDisableConfirm={false}
            />
        );
    };

    itemNameDupeCheck = () => {
        return (
            <SettingsRow
                title={"item_name_dupe_check"}
                detail={"help_text_item_name_dupe_check"}
                name={"item_name_dupe_check"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.item_name_dupe_check}
                showDisableConfirm={false}
            />
        );
    };

    purchaseOrderDupeItemCheck = () => {
        if (!this.props.supplierModel.has_purchase_orders) {
            return null;
        }

        return (
            <SettingsRow
                title={"po_item_dupe_check"}
                detail={"help_text_po_item_dupe_check"}
                name={"po_item_dupe_check"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.po_item_dupe_check}
                showDisableConfirm={false}
            />
        );
    };

    hasSampleOrders = () => {
        return (
            <SettingsRow
                title={"sample_orders"}
                detail={"help_text_sample_orders"}
                name={"has_sample_orders"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.has_sample_orders}
                showDisableConfirm={false}
            />
        );
    };

    hasQuotes = () => {
        return (
            <SettingsRow
                title={"quotes"}
                detail={"help_text_has_quotes"}
                name={"has_quotes"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.has_quotes}
                showDisableConfirm={false}
            />
        );
    };

    hasQuoteExpDate = () => {
        const component = (
            <div>
                <div className={"mt-2"}>
                    <OwLabel title={"quote_exp_num_days"} />
                    <div className={"w-5r"}>
                        <OwFnInput
                            type={"number"}
                            fn={this.handleSupplierChange}
                            name={"quote_exp_date_days"}
                            value={this.state.supplierModel.quote_exp_date_days}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"quote_exp"}
                detail={"help_text_has_quote_exp"}
                name={"has_quote_exp"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.has_quote_exp}
                showDisableConfirm={false}
                toggledOnComponent={component}
            />
        );
    };

    closeQuotesOnConvert = () => {
        if (!this.state.supplierModel.has_quotes) {
            return null;
        }

        return (
            <SettingsRow
                title={"quotes_close_on_convert"}
                detail={"help_text_quotes_close_on_convert"}
                name={"quotes_close_on_convert"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.quotes_close_on_convert}
                showDisableConfirm={false}
            />
        );
    };

    hasHidePricing = () => {
        return (
            <SettingsRow
                title={"hide_pricing"}
                detail={"help_text_hide_pricing"}
                name={"has_hide_pricing"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.has_hide_pricing}
                showDisableConfirm={false}
            />
        );
    };

    hasCsvOrderEntry = () => {
        return (
            <SettingsRow
                title={"csv_order_entry"}
                detail={"help_text_csv_order_entry"}
                name={"has_csv_order_entry"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.has_csv_order_entry}
                showDisableConfirm={false}
            />
        );
    };

    hasForecast = () => {
        return (
            <SettingsRow
                title={"forecast"}
                detail={"help_text_hide_pricing"}
                name={"has_forecast"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.has_forecast}
                showDisableConfirm={false}
            />
        );
    };

    hasCommissions = () => {
        return (
            <SettingsRow
                title={"commissions"}
                detail={"help_text_commissions"}
                name={"has_commissions"}
                toggleFn={this.handleSupplierChange}
                isActive={!!this.state.supplierModel.has_commissions}
                showDisableConfirm={false}
            />
        );
    };

    hasProductSources = () => {
        return (
            <SettingsRow
                title={"product_sources"}
                detail={"help_text_product_sources"}
                name={"has_product_sources"}
                isActive={!!this.state.supplierModel.has_product_sources}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasPickListManagement = () => {
        return (
            <SettingsRow
                title={"pick_list_management"}
                detail={"help_text_pick_list_management"}
                name={"has_pick_list_management"}
                isActive={!!this.state.supplierModel.has_pick_list_management}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasPriceGroupRestrictions = () => {
        return (
            <SettingsRow
                title={"price_group_restrictions"}
                detail={"help_text_price_group_restrictions"}
                name={"has_price_group_restrictions"}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                isActive={!!this.state.supplierModel.has_price_group_restrictions}
            />
        );
    };

    hasAutomation = () => {
        return (
            <SettingsRow
                title={"automation"}
                detail={"help_text_automation"}
                name={"has_automation"}
                isActive={!!this.state.supplierModel.has_automation}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasLocalDelivery = () => {
        return (
            <SettingsRow
                title={"local_delivery"}
                detail={"help_text_local_delivery"}
                name={"has_local_delivery"}
                isActive={!!this.state.supplierModel.has_local_delivery}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasLocalPickup = () => {
        return (
            <SettingsRow
                title={"local_pickup"}
                detail={"help_text_local_pickup"}
                name={"has_local_pickup"}
                isActive={!!this.state.supplierModel.has_local_pickup}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasVehicles = () => {
        if (!this.state.supplierModel.has_routes) {
            return null;
        }

        return (
            <SettingsRow
                title={"vehicles"}
                detail={"help_text_vehicles"}
                name={"has_vehicles"}
                isActive={!!this.state.supplierModel.has_vehicles}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasRoutes = () => {
        if (!this.state.supplierModel.has_local_pickup && !this.state.supplierModel.has_local_delivery) {
            return null;
        }

        return (
            <SettingsRow
                title={"routes"}
                detail={"help_text_routes"}
                name={"has_routes"}
                isActive={!!this.state.supplierModel.has_routes}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasDailyRoutesApp = () => {
        if (!this.props.showHiddenFeatures) {
            return null;
        }

        return (
            <SettingsRow
                title={"daily_route_app"}
                detail={"help_text_daily_route_app"}
                name={"has_daily_route_app"}
                isActive={!!this.state.supplierModel.has_daily_route_app}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasOrderEntryScanMode = () => {
        return (
            <SettingsRow
                title={"order_entry_scan_mode"}
                detail={"help_text_order_entry_scan_mode"}
                name={"has_order_entry_scan_mode"}
                isActive={!!this.state.supplierModel.has_order_entry_scan_mode}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowCreateVendorInCreateOrder = () => {
        return (
            <SettingsRow
                title={"allow_create_account_in_create_order"}
                detail={"help_text_allow_create_account_in_create_order"}
                name={"allow_create_vendor_in_create_order"}
                isActive={!!this.state.supplierModel.allow_create_vendor_in_create_order}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    ordersRequirePO = () => {
        return (
            <SettingsRow
                title={"orders_require_po"}
                detail={"help_text_orders_require_po"}
                name={"orders_require_po"}
                isActive={!!this.state.supplierModel.orders_require_po}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowEditAfterConfirm = () => {
        return (
            <SettingsRow
                title={"allow_edit_after_confirm"}
                detail={"help_text_allow_edit_after_confirm"}
                name={"allow_edit_after_confirm"}
                isActive={!!this.state.supplierModel.allow_edit_after_confirm}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    showCommonItemsModal = () => {
        return (
            <SettingsRow
                title={"show_common_items_modal"}
                detail={"help_text_show_common_items_modal"}
                name={"show_common_items_modal"}
                isActive={!!this.state.supplierModel.show_common_items_modal}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowManualPricing = () => {
        return (
            <SettingsRow
                title={"manual_pricing"}
                detail={"help_text_manual_pricing"}
                name={"allow_manual_pricing"}
                isActive={!!this.state.supplierModel.allow_manual_pricing}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowNonAdminManualPricing = () => {
        return (
            <SettingsRow
                title={"allow_non_admin_manual_pricing"}
                detail={"help_text_allow_non_admin_manual_pricing"}
                name={"allow_non_admin_manual_pricing"}
                isActive={!!this.state.supplierModel.allow_non_admin_manual_pricing}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    disableVendorOrderEntry = () => {
        if (!this.state.supplierModel.has_customer_module) {
            return null;
        } else {
            return (
                <SettingsRow
                    title={"disable_account_order_entry"}
                    detail={"help_text_disable_account_order_entry"}
                    name={"disable_vendor_order_entry"}
                    isActive={!!this.state.supplierModel.disable_vendor_order_entry}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                />
            );
        }
    };

    allowClients = () => {
        return (
            <SettingsRow
                title={"allow_clients"}
                detail={"help_text_allow_clients"}
                name={"has_client_module"}
                isActive={!!this.state.supplierModel.has_client_module}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                disabled={this.state.supplierModel.Supplier_Integration.has_woocommerce}
            />
        );
    };

    hasContacts = () => {
        return (
            <SettingsRow
                title={"contacts"}
                detail={"help_text_contacts"}
                name={"has_contacts"}
                isActive={!!this.state.supplierModel.has_contacts}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasConsignment = () => {
        return (
            <SettingsRow
                title={"consignment"}
                detail={"help_text_consignment"}
                name={"has_consignment"}
                isActive={!!this.state.supplierModel.has_consignment}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasCatalogEmail = () => {
        return (
            <SettingsRow
                title={"catalog_email"}
                detail={"help_text_catalog_email"}
                name={"has_catalog_email"}
                isActive={!!this.state.supplierModel.has_catalog_email}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasDeliveryEta = () => {
        return (
            <SettingsRow
                title={"catalog_item_delivery_eta"}
                detail={"help_text_catalog_item_delivery_eta"}
                name={"has_catalog_item_delivery_eta"}
                isActive={!!this.state.supplierModel.has_catalog_item_delivery_eta}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasTemplates = () => {
        return (
            <SettingsRow
                title={"has_templates"}
                detail={"help_text_has_templates"}
                name={"has_templates"}
                isActive={!!this.state.supplierModel.has_templates}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    templateHomeItems = () => {
        if (!this.props.supplierModel.has_templates) {
            return null;
        }

        return (
            <SettingsRow
                title={"template_home_items"}
                detail={"help_text_template_home_items"}
                name={"template_home_items"}
                isActive={!!this.state.supplierModel.template_home_items}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasDropshipping = () => {
        return (
            <SettingsRow
                title={"dropshipping"}
                detail={"help_text_has_dropshipping"}
                name={"has_dropshipping"}
                isActive={!!this.state.supplierModel.has_dropshipping}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    showOrderShipToFlags = () => {
        return (
            <SettingsRow
                title={"show_order_ship_to_flags"}
                detail={"help_text_show_order_ship_to_flags"}
                name={"show_order_ship_to_flags"}
                isActive={!!this.state.supplierModel.show_order_ship_to_flags}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hideOrderDetailInfo = () => {
        return (
            <SettingsRow
                title={"hide_order_detail_info"}
                detail={"help_text_hide_order_detail_info"}
                name={"hide_order_detail_info"}
                isActive={!!this.state.supplierModel.hide_order_detail_info}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    ecommerceListingPages = () => {
        return (
            <SettingsRow
                title={"ecommerce_item_listing_page"}
                detail={"help_text_ecommerce_item_listing_page"}
                name={"ecomm_enable_item_listing_page"}
                isActive={!!this.state.supplierModel.ecomm_enable_item_listing_page}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    ecommerceShowQtyOnHandOnCard = () => {
        return (
            <SettingsRow
                title={"ecomm_show_qoh_on_card"}
                detail={"help_text_ecomm_show_qoh_on_card"}
                name={"ecomm_show_qoh_on_card"}
                isActive={!!this.state.supplierModel.ecomm_show_qoh_on_card}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    ecommerceAllowEditOrderDetails = () => {
        return (
            <SettingsRow
                title={"ecomm_edit_order_details"}
                detail={"help_text_ecomm_edit_order_details"}
                name={"ecomm_edit_order_details"}
                isActive={!!this.state.supplierModel.ecomm_edit_order_details}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    showTotalOrderWeight = () => {
        return (
            <SettingsRow
                title={"show_total_order_weight"}
                detail={"help_text_show_total_order_weight"}
                name={"show_total_order_weight"}
                isActive={!!this.state.supplierModel.show_total_order_weight}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    orderQtyDefaultStartingNumber = () => {
        const startNumberComponent = (
            <div className={"d-flex "}>
                <div className={"d-flex"}>
                    <OwFnInput
                        fn={this.handleSupplierChange}
                        name={"order_qty_start_number"}
                        value={this.state.supplierModel.order_qty_start_number}
                        type={"number"}
                    />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"order_qty_start_number"}
                detail={"help_text_order_qty_start_number"}
                name={""}
                isActive={true}
                component={startNumberComponent}
            />
        );
    };

    creditCardSurcharge = () => {
        const creditCardSurchargeTypeOptions = [
            { title: "percent", value: PriceUpchargeTypeEnum.PERCENT },
            { title: "fixed", value: PriceUpchargeTypeEnum.FIXED },
        ];

        const surchargeComponent = (
            <div className={"d-flex "}>
                <OwLabel title={"credit_card_surcharge_rate"} className={"d-inline-flex me-2"} />
                <div className={"d-flex"}>
                    <OwFnInput
                        fn={this.handleSupplierChange}
                        name={"credit_card_surcharge"}
                        value={this.state.supplierModel.credit_card_surcharge}
                    />
                    <OwSelectOption
                        titleProp={"title"}
                        valueProp={"value"}
                        fn={this.handleSupplierChange}
                        name={"credit_card_surcharge_type"}
                        options={creditCardSurchargeTypeOptions}
                        selectedOption={this.state.supplierModel}
                        selectedOptionProp={"credit_card_surcharge_type"}
                    />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"credit_card_surcharge"}
                detail={"help_text_credit_card_surcharge"}
                name={"has_credit_card_surcharge"}
                isActive={!!this.state.supplierModel.has_credit_card_surcharge}
                toggleFn={this.handleSupplierChange}
                toggledOnComponent={surchargeComponent}
            />
        );
    };

    showFilterProductGroupsOrderEntry = () => {
        return (
            <SettingsRow
                title={"show_filter_product_groups_in_order_entry"}
                detail={"help_text_show_filter_product_groups_in_order_entry"}
                name={"show_filter_product_groups_in_order_entry"}
                isActive={!!this.state.supplierModel.show_filter_product_groups_in_order_entry}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasChildItems = () => {
        return (
            <SettingsRow
                title={"has_child_items"}
                detail={"help_text_has_child_items"}
                name={"has_child_items"}
                isActive={!!this.state.supplierModel.has_child_items}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasMap = () => {
        return (
            <SettingsRow
                title={"MAP"}
                detail={"help_text_map"}
                name={"has_map"}
                isActive={!!this.state.supplierModel.has_map}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasUomSets = () => {
        return (
            <SettingsRow
                title={"uom_sets"}
                detail={"help_text_uom_sets"}
                name={"has_uom_sets"}
                isActive={!!this.state.supplierModel.has_uom_sets}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    allowManualUomBaseQty = () => {
        return (
            <SettingsRow
                title={"allow_manual_uom_base_qty"}
                detail={"help_text_allow_manual_uom_base_qty"}
                name={"allow_manual_uom_base_qty"}
                isActive={!!this.state.supplierModel.allow_manual_uom_base_qty}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hideUomBaseQty = () => {
        return (
            <SettingsRow
                title={"hide_uom_base_qty"}
                detail={"help_text_hide_uom_base_qty"}
                name={"hide_uom_base_qty"}
                isActive={!!this.state.supplierModel.hide_uom_base_qty}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasRatioItems = () => {
        return (
            <SettingsRow
                title={"ratio_items"}
                detail={"help_text_ratio_items"}
                name={"has_ratio_items"}
                isActive={!!this.state.supplierModel.has_ratio_items}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasCustomUom = () => {
        return (
            <SettingsRow
                title={"custom_uom"}
                detail={"help_text_custom_uom"}
                name={"has_custom_uom"}
                isActive={!!this.state.supplierModel.has_custom_uom}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasCatchWeights = () => {
        return (
            <SettingsRow
                title={"catch_weights"}
                detail={"help_text_catch_weights"}
                name={"has_catch_weights"}
                isActive={!!this.state.supplierModel.has_catch_weights}
                toggleFn={this.handleSupplierChange}
                betaBadge={true}
            />
        );
    };

    allowItemPriceGroupOverride = () => {
        return (
            <SettingsRow
                title={"allow_item_price_group_override"}
                detail={"help_text_allow_item_price_group_override"}
                name={"allow_item_price_group_override"}
                isActive={!!this.state.supplierModel.allow_item_price_group_override}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    allowCreateItemInOrderEntry = () => {
        return (
            <SettingsRow
                title={"allow_create_item_in_order_entry"}
                detail={"help_text_allow_create_item_in_order_entry"}
                name={"allow_create_item_in_order_entry"}
                isActive={!!this.state.supplierModel.allow_create_item_in_order_entry}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    sumToSingleItem = () => {
        if (!this.props.supplierModel.Supplier_Integration.has_qbo) {
            return null;
        }

        return (
            <SettingsRow
                title={"sum_to_single_invoice_item"}
                detail={"help_text_sum_to_single_invoice_item"}
                name={"has_sum_to_single_invoice_item"}
                isActive={!!this.state.supplierModel.has_sum_to_single_invoice_item}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasCategoryTally = () => {
        return (
            <SettingsRow
                title={"category_tally"}
                detail={"help_text_category_tally"}
                name={"has_category_tally"}
                isActive={!!this.state.supplierModel.has_category_tally}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    rmaModule = () => {
        return (
            <SettingsRow
                title={"rma"}
                detail={"help_text_rma"}
                name={"has_rma"}
                isActive={!!this.state.supplierModel.has_rma}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    ecommerceCardView = () => {
        const cardView = this.state.supplierModel.settings.screens?.eCommerce?.cardView || {};

        const msrpVisible = !_.isNil(cardView?.msrpVisible) ? cardView?.msrpVisible : true;
        const nameVisible = !_.isNil(cardView?.nameVisible) ? cardView?.nameVisible : true;
        const skuVisible = !_.isNil(cardView?.skuVisible) ? cardView?.skuVisible : true;
        const shortDescriptionVisible = !_.isNil(cardView?.shortDescriptionVisible) ? cardView?.shortDescriptionVisible : true;
        const longDescriptionVisible = !_.isNil(cardView?.longDescriptionVisible) ? cardView?.longDescriptionVisible : true;
        const categoryVisible = !_.isNil(cardView?.categoryVisible) ? cardView?.categoryVisible : true;

        const ecommerceCardViewComponent = (
            <div>
                <div className="w-15r">
                    <EcommerceListView
                        addToCart={() => {}}
                        openDetailView={() => {}}
                        isReadOnly={true}
                        order={
                            {
                                Price_Group: { value: "wholesale" },
                            } as IOrder
                        }
                        socket={{} as Socket}
                        catalogItem={
                            {
                                has_inventory: true,
                                qty_on_hand: 100,
                                msrp: msrpVisible ? 100.0 : undefined,
                                name: nameVisible ? "Test Item Name" : "",
                                sku: skuVisible ? "TEST-SKU" : "",
                                description: longDescriptionVisible ? "Test Description" : "",
                                short_description: shortDescriptionVisible ? "Test Short Description" : "",
                                Category: categoryVisible ? { id: 1, name: "Test Category" } : null,
                                pricing: { wholesale: 100.0 },
                            } as ICatalog_Item
                        }
                        priceGroupName={"wholesale"}
                    />
                </div>

                <div>
                    <OwLabel title="card_view_items" isBold={true} isUnderline={true} className="mb-2" />
                </div>
                <div>
                    <OwToggle
                        fn={(e) => {
                            this.handleSupplierSettingsChange(e, "eCommerce", "cardView");
                        }}
                        name={"nameVisible"}
                        label={"name"}
                        active={nameVisible}
                        labelOnRight={true}
                    />
                </div>
                <div>
                    <OwToggle
                        fn={(e) => {
                            this.handleSupplierSettingsChange(e, "eCommerce", "cardView");
                        }}
                        name={"skuVisible"}
                        label={"sku"}
                        active={skuVisible}
                        labelOnRight={true}
                    />
                </div>
                <div>
                    <OwToggle
                        fn={(e) => {
                            this.handleSupplierSettingsChange(e, "eCommerce", "cardView");
                        }}
                        name={"msrpVisible"}
                        label={"msrp"}
                        active={msrpVisible}
                        labelOnRight={true}
                    />
                </div>
                <div>
                    <OwToggle
                        fn={(e) => {
                            this.handleSupplierSettingsChange(e, "eCommerce", "cardView");
                        }}
                        name={"shortDescriptionVisible"}
                        label={"short_description"}
                        active={shortDescriptionVisible}
                        labelOnRight={true}
                    />
                </div>
                <div>
                    <OwToggle
                        fn={(e) => {
                            this.handleSupplierSettingsChange(e, "eCommerce", "cardView");
                        }}
                        name={"longDescriptionVisible"}
                        label={"long_description"}
                        active={longDescriptionVisible}
                        labelOnRight={true}
                    />
                </div>
                <div>
                    <OwToggle
                        fn={(e) => {
                            this.handleSupplierSettingsChange(e, "eCommerce", "cardView");
                        }}
                        name={"categoryVisible"}
                        label={"category"}
                        active={categoryVisible}
                        labelOnRight={true}
                    />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"ecommerce_card_view"}
                detail={"help_text_ecommerce_card_view"}
                name={"ecommerce_card_view"}
                component={ecommerceCardViewComponent}
            />
        );
    };

    persistItemOptionSelection = () => {
        return (
            <SettingsRow
                title={"persist_item_option_selection"}
                detail={"help_text_persist_item_option_selection"}
                name={"persist_item_option_selection"}
                isActive={!!this.state.supplierModel.persist_item_option_selection}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    allowFreeEntryItem = () => {
        return (
            <SettingsRow
                title={"allow_free_entry_item"}
                detail={"help_text_allow_free_entry_item"}
                name={"allow_free_entry_items"}
                isActive={!!this.state.supplierModel.allow_free_entry_items}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasApproveDecline = () => {
        return (
            <SettingsRow
                title={"approve_decline"}
                detail={"help_text_approve_decline"}
                name={"has_approve_decline"}
                isActive={!!this.state.supplierModel.has_approve_decline}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasPricingDescriptions = () => {
        return (
            <SettingsRow
                title={"pricing_descriptions"}
                detail={"help_text_has_pricing_descriptions"}
                name={"has_pricing_descriptions"}
                isActive={!!this.state.supplierModel.has_pricing_descriptions}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    ordersStartInEditMode = () => {
        return (
            <SettingsRow
                title={"orders_start_in_edit_mode"}
                detail={"help_text_orders_start_in_edit_mode"}
                name={"orders_start_in_edit_mode"}
                isActive={!!this.state.supplierModel.orders_start_in_edit_mode}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    accountOnlyViewUserOrders = () => {
        return (
            <SettingsRow
                title={"account_users_only_view_own_orders"}
                detail={"help_text_account_users_only_view_own_orders"}
                name={"account_users_only_view_own_orders"}
                isActive={!!this.state.supplierModel.account_users_only_view_own_orders}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    accountCreditLimits = () => {
        return (
            <SettingsRow
                title={"account_credit_limits"}
                detail={"help_text_account_credit_limits"}
                name={"has_vendor_credit_limits"}
                isActive={!!this.state.supplierModel.has_vendor_credit_limits}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    stateLicenseField = () => {
        return (
            <SettingsRow
                title={"account_state_license"}
                detail={"help_text_account_state_license"}
                name={"has_account_state_license"}
                isActive={!!this.state.supplierModel.has_account_state_license}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasCurrencies = () => {
        return (
            <SettingsRow
                title={"currencies"}
                detail={"help_text_currencies"}
                name={"has_currencies"}
                isActive={!!this.state.supplierModel.has_currencies}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    defaultNewAccountCatalogAndPriceGroup = () => {
        const defaultNewAccountCatalogComponent = (
            <div>
                <div>
                    <div className={"d-flex flex-column mb-5"}>
                        <OwLabel title={"catalog"} />
                        <div className={"w-15r"}>
                            <OwSelectOption
                                titleProp={"name"}
                                valueProp={"id"}
                                name={"default_new_account_catalog_id"}
                                options={this.state.catalogs}
                                selectedOption={this.state.supplierModel}
                                selectedOptionProp={"default_new_account_catalog_id"}
                                fn={this.handleSupplierChange}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                    <div className={"d-flex flex-column mt-5 mb-5"}>
                        <OwLabel title={"price_group"} />
                        <div className={"w-15r"}>
                            <OwSelectOption
                                titleProp={"value"}
                                valueProp={"id"}
                                name={"default_new_account_price_group_id"}
                                options={this.state.priceGroups}
                                selectedOption={this.state.supplierModel}
                                selectedOptionProp={"default_new_account_price_group_id"}
                                fn={this.handleSupplierChange}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"default_new_account_catalog"}
                detail={"help_text_default_new_account_catalog"}
                name={"default_new_account_catalog"}
                component={defaultNewAccountCatalogComponent}
            />
        );
    };

    autoRemoveZeroQtyLineItems = () => {
        return (
            <SettingsRow
                title={"auto_remove_zero_qty_line_items"}
                detail={"help_text_auto_remove_zero_qty_line_items"}
                name={"auto_remove_zero_qty_line_items"}
                isActive={!!this.state.supplierModel.auto_remove_zero_qty_line_items}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    allowSalesUsersToEditPricing = () => {
        return (
            <SettingsRow
                title={"allow_sales_users_to_edit_pricing"}
                detail={"help_text_allow_sales_users_to_edit_pricing"}
                name={"allow_sales_users_to_edit_pricing"}
                isActive={!!this.state.supplierModel.allow_sales_users_to_edit_pricing}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    closeDock = () => {
        this.setState({
            isDockVisible: false,
            dockComponent: null,
        });
    };

    editScreenOptions = () => {
        const dockComponent = <EditScreenOptions socket={this.props.socket} notifyFn={this.props.notifyFn} closeFn={this.closeDock} />;

        this.setState({
            isDockVisible: true,
            dockComponent,
        });
    };

    getScreenOptions = () => {
        const component = <OwButton title={"edit_screen_options"} fn={this.editScreenOptions} />;

        return <SettingsRow title={"screen_options"} detail={"help_text_screen_options"} name={"screen_options"} component={component} />;
    };

    getNoIncrementDetails = () => {
        const incrementComponent = (
            <div>
                <div>
                    <div>
                        <OwLabel title={"key"} />
                    </div>
                    <div>
                        <OwFnInput fn={this.handleSupplierChange} name={"order_no_key"} value={this.state.supplierModel.order_no_key} />
                    </div>
                </div>

                <div className={"mt-3"}>
                    <div>
                        <OwLabel title={"order_no_current_incr"} />
                    </div>
                    <div>
                        <OwFnInput
                            fn={this.handleSupplierChange}
                            name={"order_no_current_incr"}
                            value={this.state.supplierModel.order_no_current_incr}
                            type={"number"}
                        />
                    </div>
                    <div className={"mt-3"}>
                        <OwLabel title={"example"} postText={":"} className={"me-2"} />
                        {this.state.supplierModel.order_no_key}-{this.state.supplierModel.order_no_current_incr}
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"increment_values"}
                detail={"help_text_increment_values"}
                name={""}
                isActive={true}
                component={incrementComponent}
            />
        );
    };

    hasBillOfLading = () => {
        const billOfLadingSettings = (
            <div>
                <div>
                    <div>
                        <OwLabel title={"shipper_legal_copy"} />
                    </div>
                    <div>
                        <OwTextArea
                            name={"shipperLegalCopy"}
                            fn={(e) => {
                                this.handleBolLDetailChange(e, "shipperLegalCopy");
                            }}
                            value={this.state.supplierModel.bill_of_lading_details?.shipperLegalCopy}
                        />
                    </div>
                </div>

                <div className={"mt-3"}>
                    <div>
                        <OwLabel title={"receiver_legal_copy"} />
                    </div>
                    <div>
                        <OwTextArea
                            name={"receiverLegalCopy"}
                            fn={(e) => {
                                this.handleBolLDetailChange(e, "receiverLegalCopy");
                            }}
                            value={this.state.supplierModel.bill_of_lading_details?.receiverLegalCopy}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"bill_of_lading"}
                detail={"help_text_bill_of_lading"}
                name={"has_bill_of_lading"}
                isActive={!!this.props.supplierModel.has_bill_of_lading}
                toggleFn={this.handleSupplierChange}
                toggledOnComponent={billOfLadingSettings}
            />
        );
    };

    getSalesOrderFooter = () => {
        const salesOrderFooter = (
            <div>
                <div>
                    <div>
                        <OwTextArea
                            name={"sales_order_footer"}
                            fn={(e) => {
                                this.handleSupplierChange(e);
                            }}
                            value={this.state.supplierModel.sales_order_footer}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"sales_order_footer"}
                detail={"help_text_sales_order_footer"}
                name={"sales_order_footer"}
                isActive={true}
                toggleFn={() => {}}
                component={salesOrderFooter}
            />
        );
    };

    getInvoiceFooter = () => {
        const invoiceFooter = (
            <div>
                <div>
                    <div>
                        <OwTextArea
                            name={"invoice_footer"}
                            fn={(e) => {
                                this.handleSupplierChange(e);
                            }}
                            value={this.state.supplierModel.invoice_footer}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"invoice_footer"}
                detail={"help_text_invoice_footer"}
                name={"invoice_footer"}
                isActive={true}
                toggleFn={() => {}}
                component={invoiceFooter}
            />
        );
    };

    getQuoteFooter = () => {
        if (!this.props.supplierModel.has_quotes) {
            return null;
        }

        const quoteFooter = (
            <div>
                <div>
                    <div>
                        <OwTextArea
                            name={"quote_footer"}
                            fn={(e) => {
                                this.handleSupplierChange(e);
                            }}
                            value={this.state.supplierModel.quote_footer}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"quote_footer"}
                detail={"help_text_quote_footer"}
                name={"quote_footer"}
                isActive={true}
                toggleFn={() => {}}
                component={quoteFooter}
            />
        );
    };

    defaultFreightPolicy = () => {
        const freightPolicy = (
            <div>
                <div>
                    <div>
                        <OwTextArea
                            name={"default_freight_policy"}
                            fn={(e) => {
                                this.handleSupplierChange(e);
                            }}
                            value={this.state.supplierModel.default_freight_policy}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"default_freight_policy"}
                detail={"help_text_default_freight_policy"}
                name={"quote_footer"}
                isActive={true}
                toggleFn={() => {}}
                component={freightPolicy}
            />
        );
    };

    addressValidations = () => {
        const addressValidationComponent = (
            <div>
                {this.state.supplierModel.addr_validation_count} / {this.state.supplierModel.addr_validation_limit}
                <div className={"text-small text-muted w-25r"}>
                    <OwLabel title={"address_validation_limit_detail"} />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"address_validation"}
                detail={"help_text_address_validation"}
                name={"has_address_validation"}
                isActive={!!this.state.supplierModel.has_address_validation}
                toggleFn={this.handleSupplierChange}
                disabled={true}
                toggledOnComponent={addressValidationComponent}
            />
        );
    };

    docLogoDetail = () => {
        return (
            <tr>
                <td className={"text-end"}>
                    <div>
                        <OwLabel title={"doc_logo"} className={"d-inline-flex me-2"} />
                    </div>
                    <div className={"mt-2"}>
                        <OwLabel title={"help_text_doc_logo"} className={"text-muted mt-4"} />
                    </div>
                </td>
                <td>
                    <div className={"col-12 col-md-4 col-lg-3 .g-0 mt-5 mb-5"}>
                        <OwS3Uploader
                            socket={this.props.socket}
                            isReadOnly={false}
                            resourceType={FileUploadResourceTypeEnum.docLogo}
                            supplierModel={this.props.supplierModel}
                            userModel={this.props.userModel}
                            isDocLogo={true}
                        />
                    </div>
                    <div>
                        {this.props.supplierModel.Doc_Logo ? (
                            <div className={"d-inline-flex bg-white p-3"}>
                                <DocLogo maxWidth={"20rem"} height={"auto"} />
                            </div>
                        ) : null}
                    </div>
                </td>
            </tr>
        );
    };

    hasWhiteLabel = () => {
        const whiteLabelComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_white_label}
                            name={"has_white_label"}
                            fn={this.handleSupplierChange}
                            label={""}
                            showDisableConfirm={false}
                        />
                    </div>
                </div>

                {this.props.supplierModel.has_white_label ? (
                    <div>
                        <div className={"col-12 col-md-4 col-lg-3 .g-0 mt-5 mb-5"}>
                            <OwLabel title={"dark_mode_logo"} />
                            <OwS3Uploader
                                socket={this.props.socket}
                                isReadOnly={false}
                                resourceType={FileUploadResourceTypeEnum.logo}
                                supplierModel={this.props.supplierModel}
                                userModel={this.props.userModel}
                                isWhiteLabelLogo={true}
                            />
                            <div className={"mt-5"} style={{ width: "20rem" }}>
                                <WhiteLabelLogo maxWidth={"100%"} height={"auto"} />
                            </div>
                        </div>

                        <div className={"col-12 col-md-4 col-lg-3 .g-0"}>
                            <OwLabel title={"light_mode_logo"} />
                            <OwS3Uploader
                                socket={this.props.socket}
                                isReadOnly={false}
                                resourceType={FileUploadResourceTypeEnum.logo}
                                supplierModel={this.props.supplierModel}
                                userModel={this.props.userModel}
                                isWhiteLabelLightLogo={true}
                            />
                            <div className={"mt-5 bg-white p-3"} style={{ width: "20rem" }}>
                                <WhiteLabelLogo maxWidth={"100%"} height={"auto"} lightLogo={true} />
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow title={"white_label"} detail={"help_text_white_label"} name={"has_white_label"} component={whiteLabelComponent} />
        );
    };

    hasPricingOnInventory = () => {
        return (
            <SettingsRow
                title={"pricing_on_inventory"}
                detail={"help_text_pricing_on_inventory"}
                name={"has_pricing_on_inventory"}
                isActive={!!this.state.supplierModel.has_pricing_on_inventory}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    inventoryScreenReadOnly = () => {
        return (
            <SettingsRow
                title={"inventory_screen_read_only"}
                detail={"help_text_inventory_screen_read_only"}
                name={"inventory_screen_read_only"}
                isActive={!!this.state.supplierModel.inventory_screen_read_only}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hideCategoryAttributes = () => {
        return (
            <SettingsRow
                title={"hide_category_attributes"}
                detail={"help_text_hide_category_attributes"}
                name={"hide_category_attributes"}
                isActive={!!this.state.supplierModel.hide_category_attributes}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hideVendorPriceGroupSelect = () => {
        return (
            <SettingsRow
                title={"hide_vendor_price_group_select"}
                detail={"help_text_hide_price_group_select"}
                name={"hide_vendor_price_group_select"}
                isActive={!!this.state.supplierModel.hide_vendor_price_group_select}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    noDuplicateOrderItems = () => {
        return (
            <SettingsRow
                title={"no_dupe_order_items"}
                detail={"help_text_no_dupe_order_items"}
                name={"no_dupe_order_items"}
                isActive={!!this.state.supplierModel.no_dupe_order_items}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasCostPricing = () => {
        const costPricingComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_cost_pricing}
                            name={"has_cost_pricing"}
                            fn={this.handleSupplierChange}
                            label={""}
                            showDisableConfirm={false}
                        />
                    </div>
                </div>

                {this.state.supplierModel.has_cost_pricing ? (
                    <div className={"d-flex flex-column"}>
                        <div>
                            <OwLabel title={"cost_pricing_admin_only"} noBottomMargin={true} />
                        </div>
                        <div className={""}>
                            <OwToggle
                                active={!!this.state.supplierModel.cost_pricing_admin_only}
                                name={"cost_pricing_admin_only"}
                                fn={this.handleSupplierChange}
                                label={""}
                                showDisableConfirm={false}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"cost_pricing"}
                detail={"help_text_has_cost_pricing"}
                name={"has_cost_pricing"}
                component={costPricingComponent}
            />
        );
    };

    disableJoinCode = () => {
        return (
            <SettingsRow
                title={"disable_join_code"}
                detail={"help_text_disable_join_code"}
                name={"disable_join_code"}
                isActive={!!this.state.supplierModel.disable_join_code}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowSalesRepsCreateAccounts = () => {
        return (
            <SettingsRow
                title={"allow_sales_reps_create_accounts"}
                detail={"help_text_allow_sales_reps_create_accounts"}
                name={"allow_sales_reps_create_accounts"}
                isActive={!!this.state.supplierModel.allow_sales_reps_create_accounts}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasDimensions = () => {
        const toggleOnComponent = (
            <div className="mt-4">
                <div className="mb-2">
                    <OwToggle
                        fn={this.handleSupplierChange}
                        name={"length_for_depth"}
                        label={"length_for_depth"}
                        active={!!this.state.supplierModel.length_for_depth}
                        showDisableConfirm={false}
                        labelOnRight={true}
                    />
                </div>

                <div className="d-flex align-items-center mb-2">
                    <OwToggle
                        fn={this.handleSupplierChange}
                        name={"show_dimension_widget"}
                        label={"show_dimension_widget"}
                        active={!!this.state.supplierModel.show_dimension_widget}
                        showDisableConfirm={false}
                        labelOnRight={true}
                    />
                    <OwIconTooltip
                        iconClassName={"fad fa-info-circle ms-2"}
                        tooltipContent={"help_text_show_dimension_widget"}
                        translateContent={true}
                    />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"has_dimensions"}
                detail={"help_text_has_dimensions"}
                name={"has_dimensions"}
                isActive={!!this.state.supplierModel.has_dimensions}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                toggledOnComponent={toggleOnComponent}
            />
        );
    };

    hasPriceAdjustments = () => {
        return (
            <SettingsRow
                title={"price_adjustments"}
                detail={"help_text_has_price_adjustments"}
                name={"has_price_adjustments"}
                isActive={!!this.state.supplierModel.has_price_adjustments}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasPricingFormulas = () => {
        return (
            <SettingsRow
                title={"pricing_formulas"}
                detail={"help_text_has_pricing_formulas"}
                name={"has_pricing_formulas"}
                isActive={!!this.state.supplierModel.has_pricing_formulas}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasLaborFee = () => {
        return (
            <SettingsRow
                title={"labor_fee"}
                detail={"help_text_has_labor_fee"}
                name={"has_price_adjustments"}
                isActive={!!this.state.supplierModel.has_labor_fee}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasShippingFee = () => {
        return (
            <SettingsRow
                title={"shipping_fee"}
                detail={"help_text_has_shipping_fee"}
                name={"has_shipping_fee"}
                isActive={!!this.state.supplierModel.has_shipping_fee}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    costPricingAdminOnly = () => {};

    hasAnalytics = () => {
        return (
            <SettingsRow
                title={"analytics"}
                detail={"help_text_has_analytics"}
                name={"has_analytics"}
                isActive={!!this.state.supplierModel.has_analytics}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasExpedited = () => {
        return (
            <SettingsRow
                title={"expedited"}
                detail={"help_text_has_expedited"}
                name={"has_expedited"}
                isActive={!!this.state.supplierModel.has_expedited}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                disabled={this.state.supplierModel.has_service_levels}
            />
        );
    };

    hasProjects = () => {
        return (
            <SettingsRow
                title={"projects"}
                detail={"help_text_has_projects"}
                name={"has_projects"}
                isActive={!!this.state.supplierModel.has_projects}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasPurchaseOrders = () => {
        const purchaseOrderOptions = (
            <div>
                <OwToggle
                    fn={this.handleSupplierChange}
                    name={"has_create_po_from_orders"}
                    label={"create_from_order"}
                    labelOnRight={true}
                    active={!!this.state.supplierModel.has_create_po_from_orders}
                />
            </div>
        );

        return (
            <SettingsRow
                title={"purchase_orders"}
                detail={"help_text_purchase_orders"}
                name={"has_purchase_orders"}
                isActive={!!this.state.supplierModel.has_purchase_orders}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                toggledOnComponent={purchaseOrderOptions}
            />
        );
    };

    promptCreatePo = () => {
        return (
            <SettingsRow
                title={"prompt_order_entry_create_po"}
                detail={"help_text_prompt_order_entry_create_po"}
                name={"prompt_order_entry_create_po"}
                isActive={!!this.state.supplierModel.prompt_order_entry_create_po}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    showPoStatusOnOrderScreen = () => {
        return (
            <SettingsRow
                title={"show_po_status_order_screen"}
                detail={"help_text_show_po_status_order_screen"}
                name={"show_po_status_order_screen"}
                isActive={!!this.state.supplierModel.show_po_status_order_screen}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasThirdPartyOrderRef = () => {
        return (
            <SettingsRow
                title={"third_party_order_ref"}
                detail={"help_text_third_party_order_ref"}
                name={"has_third_party_order_ref"}
                isActive={!!this.state.supplierModel.has_third_party_order_ref}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowBackToPrelim = () => {
        return (
            <SettingsRow
                title={"allow_back_to_preliminary"}
                detail={"help_text_allow_back_to_preliminary"}
                name={"allow_back_to_prelim"}
                isActive={!!this.state.supplierModel.allow_back_to_prelim}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    redirectOnSubmit = () => {
        return (
            <SettingsRow
                title={"redirect_to_orders_on_submit"}
                detail={"help_text_redirect_to_orders_on_submit"}
                name={"redirect_on_submit"}
                isActive={!!this.state.supplierModel.redirect_on_submit}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    oneOrderPerPickList = () => {
        if (!this.props.supplierModel.has_pick_list_management) {
            return null;
        }

        return (
            <SettingsRow
                title={"one_order_per_pick_list"}
                detail={"help_text_one_order_per_pick_list"}
                name={"one_order_per_pick_list"}
                isActive={!!this.state.supplierModel.one_order_per_pick_list}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasOrderBonus = () => {
        return (
            <SettingsRow
                title={"order_bonus"}
                detail={"help_text_has_order_bonus"}
                name={"has_order_bonus"}
                isActive={!!this.state.supplierModel.has_order_bonus}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    editShippingWeightTiers = () => {
        const component = (
            <ShippingZoneWeightTiersSidebar
                cancelFn={this.hideSidebar}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                setActivityIndicator={this.props.setActivityIndicator}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    editShippingZones = () => {
        const component = (
            <ShippingZonesSidebar
                cancelFn={this.hideSidebar}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                setActivityIndicator={this.props.setActivityIndicator}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    showShippingCarriersSidebar = () => {
        const component = (
            <EditShippingCarriersSidebar
                cancelFn={this.hideSidebar}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                setActivityIndicator={this.props.setActivityIndicator}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    shippingDefaultCharge = () => {
        const upchargeTypeOptions = [
            { value: PriceUpchargeTypeEnum.FIXED, title: "Fixed" },
            { value: PriceUpchargeTypeEnum.PERCENT, title: "Percent" },
        ];
        const shippingDefaultChargeComponent = (
            <div className={"d-flex"}>
                <div className={"d-flex"}>
                    <div className={"w-5r me-1"}>
                        <OwFnInput
                            name={"default_shipping_amount"}
                            type={"number"}
                            value={this.state.supplierModel.default_shipping_amount}
                            fn={this.handleSupplierChange}
                            min={0}
                        />
                    </div>
                    <div className={"w-7r"}>
                        <OwSelectOption
                            valueProp={"value"}
                            titleProp={"title"}
                            name={"default_shipping_type_id"}
                            options={upchargeTypeOptions}
                            fn={this.handleSupplierChange}
                            selectedOption={this.state.supplierModel}
                            selectedOptionProp={"default_shipping_type_id"}
                            showBlankFirst={true}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                name={"shipping_default_charge"}
                title={"shipping_default_charge"}
                detail={"help_text_shipping_default_charge"}
                component={shippingDefaultChargeComponent}
            />
        );
    };

    editOrderTotalTiers = () => {
        const component = <OrderTotalTiersSidebar cancelFn={this.hideSidebar} />;

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    hasShippingByOrderTotal = () => {
        const shippingByOrderTotalComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwButton title="order_total_tiers" fn={this.editOrderTotalTiers} />
                    </div>
                </div>

                <div className={"mt-4"}>
                    <OwLabel title="max_order_total_for_auto_shipping" />
                    <div className={"w-10r"}>
                        <OwFnInput
                            name="max_order_total_for_auto_shipping"
                            value={this.state.supplierModel.max_order_total_for_auto_shipping}
                            fn={this.handleSupplierChange}
                        />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"shipping_amount_by_order_total"}
                detail={"help_text_shipping_amount_by_order_total"}
                name={"has_shipping_by_order_total"}
                isActive={!!this.state.supplierModel.has_shipping_by_order_total}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                toggledOnComponent={shippingByOrderTotalComponent}
            />
        );
    };

    hasShippingByWeight = () => {
        const shippingByWeightComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_shipping_by_weight}
                            name={"has_shipping_by_weight"}
                            fn={this.handleSupplierChange}
                            label={""}
                            showDisableConfirm={false}
                        />
                    </div>
                    {this.state.supplierModel.has_shipping_by_weight ? (
                        <div className={"ms-4"}>
                            <OwToggle
                                fn={this.handleSupplierChange}
                                name={"has_shipping_by_weight_state"}
                                label={"by_state"}
                                active={!!this.state.supplierModel.has_shipping_by_weight_state}
                                showDisableConfirm={false}
                            />
                        </div>
                    ) : null}
                </div>

                {this.state.supplierModel.has_shipping_by_weight ? (
                    <div className={"d-flex flex-column mt-3"}>
                        <div className={"d-flex"}>
                            <div className={""}>
                                <OwButton
                                    labelClassName={"no-wrap"}
                                    leftIconClass={"fad fa-layer-group"}
                                    title={
                                        this.state.supplierModel.has_shipping_by_weight_state
                                            ? "shipping_state_weight_tiers"
                                            : "shipping_zone_weight_tiers"
                                    }
                                    fn={this.editShippingWeightTiers}
                                />
                            </div>
                            {this.state.supplierModel.has_shipping_by_weight_state ? null : (
                                <div className={"ms-2"}>
                                    <OwButton
                                        leftIconClass={"fad fa-globe-americas"}
                                        title={"shipping_zones"}
                                        fn={this.editShippingZones}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"has_shipping_by_weight"}
                detail={"help_text_has_shipping_by_weight"}
                name={"has_shipping_by_weight"}
                isActive={!!this.state.supplierModel.has_shipping_by_weight}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                component={shippingByWeightComponent}
            />
        );
    };

    hasSpecDueDate = () => {
        const specDueDateComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_spec_due_date}
                            name={"has_spec_due_date"}
                            fn={this.handleSupplierChange}
                            label={""}
                            showDisableConfirm={false}
                        />
                    </div>
                </div>

                {this.state.supplierModel.has_spec_due_date ? (
                    <div className={"d-flex flex-column mt-3"}>
                        <div className={""}>
                            <OwLabel title={"before_due_reminder_days"} />
                            <div className={"w-10r"}>
                                <OwInputWrapper
                                    name={"spec_due_reminder_no_days"}
                                    fn={this.handleSupplierChange}
                                    value={this.state.supplierModel.spec_due_reminder_no_days}
                                />
                            </div>
                        </div>

                        <div className={"mt-4"}>
                            <OwLabel title={"repeat_past_due_interval_days"} />
                            <div className={"w-10r"}>
                                <OwInputWrapper
                                    name={"spec_due_repeat_past_due_interval"}
                                    fn={this.handleSupplierChange}
                                    value={this.state.supplierModel.spec_due_repeat_past_due_interval}
                                />
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"spec_due_date"}
                detail={"help_text_has_spec_due_date"}
                name={"has_spec_due_date"}
                isActive={!!this.state.supplierModel.has_spec_due_date}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                component={specDueDateComponent}
            />
        );
    };

    /**
     * @deprecated
     */
    showOfflineToggleInHeader = () => {
        return (
            <SettingsRow
                title={"show_offline_toggle_in_header"}
                detail={"help_text_show_offline_toggle_in_header"}
                name={"show_offline_in_header"}
                isActive={!!this.state.supplierModel.show_offline_in_header}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    requirePoOnConvertToQuote = () => {
        if (!this.state.supplierModel.has_quotes) {
            return null;
        }

        return (
            <SettingsRow
                title={"require_po_on_convert_quote"}
                detail={"help_text_require_po_on_convert_quote"}
                name={"require_po_on_convert_quote"}
                isActive={!!this.state.supplierModel.require_po_on_convert_quote}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    onPackingListPerPickList = () => {
        if (!this.state.supplierModel.has_pick_list_management) {
            return null;
        }

        return (
            <SettingsRow
                title={"one_packing_list_per_pick_list"}
                detail={"help_text_one_packing_list_per_pick_list"}
                name={"one_packing_list_per_pick_list"}
                isActive={!!this.state.supplierModel.one_packing_list_per_pick_list}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    pickListScanMode = () => {
        if (!this.props.supplierModel.has_pick_list_management) {
            return null;
        }

        return (
            <SettingsRow
                title={"pick_list_scan_mode_active"}
                detail={"help_text_pick_list_scan_mode_active"}
                name={"pick_list_scan_mode_active"}
                isActive={!!this.state.supplierModel.pick_list_scan_mode_active}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasPickListRowSteps = () => {
        if (!this.props.supplierModel.has_pick_list_management) {
            return null;
        }

        return (
            <SettingsRow
                title={"has_pick_list_row_steps"}
                detail={"help_text_has_pick_list_row_steps"}
                name={"has_pick_list_row_steps"}
                isActive={!!this.state.supplierModel.has_pick_list_row_steps}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasRemakes = () => {
        const remakeComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_remakes}
                            name={"has_remakes"}
                            fn={this.handleSupplierChange}
                            label={""}
                            showDisableConfirm={false}
                        />
                    </div>
                </div>

                {this.state.supplierModel.has_remakes ? (
                    <div className={"d-flex flex-column"}>
                        <div className={"mt-3"}>
                            <OwLabel title={"remake_cancels_original_order"} noBottomMargin={true} />
                        </div>
                        <div className={""}>
                            <OwToggle
                                active={!!this.state.supplierModel.remake_cancels_parent}
                                name={"remake_cancels_parent"}
                                fn={this.handleSupplierChange}
                                label={""}
                                showDisableConfirm={false}
                            />
                        </div>

                        <div className={"mt-3"}>
                            <OwLabel title={"hide_remake_from_accounts"} noBottomMargin={true} />
                        </div>
                        <div className={""}>
                            <OwToggle
                                active={!!this.state.supplierModel.hide_remake_from_accounts}
                                name={"hide_remake_from_accounts"}
                                fn={this.handleSupplierChange}
                                label={""}
                                showDisableConfirm={false}
                            />
                        </div>

                        <div className={"mt-3"}>
                            <OwLabel title={"hide_cancelled_from_accounts"} noBottomMargin={true} />
                        </div>
                        <div className={""}>
                            <OwToggle
                                active={!!this.state.supplierModel.hide_cancelled_from_accounts}
                                name={"hide_cancelled_from_accounts"}
                                fn={this.handleSupplierChange}
                                label={""}
                                showDisableConfirm={false}
                            />
                        </div>

                        {this.props.supplierModel.has_service_levels ? (
                            <div>
                                <div className={"mt-3"}>
                                    <OwLabel title={"remake_default_service_level"} />
                                </div>
                                <div className={"row"}>
                                    <div className={"col-12 col-md-4"}>
                                        <OwSelectOption
                                            name={"default_remake_service_level_id"}
                                            options={this.state.serviceLevels}
                                            titleProp={"name"}
                                            valueProp={"id"}
                                            fn={this.handleSupplierChange}
                                            showBlankFirst={true}
                                            selectedOption={this.state.supplierModel}
                                            selectedOptionProp={"default_remake_service_level_id"}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"remakes"}
                detail={"help_text_remakes"}
                name={"has_remakes"}
                isActive={!!this.state.supplierModel.has_remakes}
                toggleFn={this.handleSupplierChange}
                component={remakeComponent}
                showDisableConfirm={false}
            />
        );
    };

    hasReorders = () => {
        return (
            <SettingsRow
                title={"reorders"}
                detail={"help_text_has_reorders"}
                name={"has_reorders"}
                isActive={!!this.state.supplierModel.has_reorders}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasBom = () => {
        return (
            <SettingsRow
                title={"has_bom"}
                detail={"help_text_has_bom"}
                name={"has_bom"}
                isActive={!!this.state.supplierModel.has_bom}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasShipments = () => {
        return (
            <SettingsRow
                title={"has_shipments"}
                detail={"help_text_has_shipments"}
                name={"has_shipments"}
                isActive={!!this.state.supplierModel.has_shipments}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    passThroughShippingCosts = () => {
        return (
            <SettingsRow
                title={"pass_through_shipping_costs"}
                detail={"help_text_pass_through_shipping_costs"}
                name={"pass_through_shipping_costs"}
                isActive={!!this.state.supplierModel.pass_through_shipping_costs}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    shippingCarriers = () => {
        const shippingCarriersComponent = (
            <div>
                <div className={""}>
                    <OwButton title={"edit_shipping_carriers"} fn={this.showShippingCarriersSidebar} leftIconClass={"fad fa-truck"} />
                </div>
            </div>
        );
        return (
            <SettingsRow
                title={"shipping_carriers"}
                detail={"help_text_shipping_carriers"}
                name={"shipping_carriers"}
                component={shippingCarriersComponent}
            />
        );
    };

    hasCubes = () => {
        const hasCubesComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_cubes}
                            name={"has_cubes"}
                            fn={this.handleSupplierChange}
                            label={""}
                            showDisableConfirm={false}
                        />
                    </div>
                </div>

                {this.state.supplierModel.has_cubes ? (
                    <div className={"d-flex flex-column"}>
                        <div className={"mt-3"}>
                            <OwLabel title={"order_minimum_cubes_required"} noBottomMargin={true} />
                        </div>
                        <div className={"col-12 col-md-4 .g-0"}>
                            <OwInputWrapper
                                type={"number"}
                                name={"order_minimum_cubes_required"}
                                fn={this.handleSupplierChange}
                                value={this.state.supplierModel.order_minimum_cubes_required}
                            />
                            <OwSelectOption
                                titleProp={"value"}
                                valueProp={"id"}
                                fn={this.handleSupplierChange}
                                name={"cube_uom_id"}
                                options={SystemConst.UnitOfMeasurementOptions}
                                selectedOption={this.state.supplierModel}
                                selectedOptionProp={"cube_uom_id"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"cubes"}
                detail={"help_text_has_cubes"}
                name={"has_cubes"}
                isActive={!!this.state.supplierModel.has_cubes}
                toggleFn={this.handleSupplierChange}
                component={hasCubesComponent}
                showDisableConfirm={false}
            />
        );
    };

    allowInventoryScreenOrder = () => {
        return (
            <SettingsRow
                title={"allow_inventory_screen_order"}
                detail={"help_text_allow_inventory_screen_order"}
                name={"allow_inventory_screen_order"}
                isActive={!!this.state.supplierModel.allow_inventory_screen_order}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hideCatalogViewer = () => {
        return (
            <SettingsRow
                title={"hide_catalog_viewer"}
                detail={"help_text_hide_catalog_viewer"}
                name={"hide_catalog_viewer"}
                isActive={!!this.state.supplierModel.hide_catalog_viewer}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hideCategoryViewer = () => {
        return (
            <SettingsRow
                title={"hide_category_viewer"}
                detail={"help_text_hide_category_viewer"}
                name={"hide_category_viewer"}
                isActive={!!this.state.supplierModel.hide_category_viewer}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasExports = () => {
        return (
            <SettingsRow
                title={"exports"}
                detail={"help_text_exports"}
                name={"has_exports"}
                isActive={!!this.state.supplierModel.has_exports}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    editCustomImports = () => {
        this.props.navigate("/business/custom-imports");
    };

    hasCustomImports = () => {
        if (!this.props.showHiddenFeatures) {
            return null;
        }

        const customImportsComponent = (
            <div>
                <div className={""}>
                    <OwToggle
                        active={!!this.state.supplierModel.has_custom_imports}
                        name={"has_custom_imports"}
                        fn={this.handleSupplierChange}
                        label={""}
                        showDisableConfirm={false}
                        disabled={false}
                    />
                    <div>
                        {this.props.supplierModel.has_custom_imports ? (
                            <OwButton title={"edit_custom_imports"} fn={this.editCustomImports} leftIconClass={"fad fa-file-import"} />
                        ) : null}
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"has_custom_imports"}
                detail={"help_text_has_custom_imports"}
                name={"has_custom_imports"}
                isActive={!!this.state.supplierModel.has_custom_imports}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                component={customImportsComponent}
            />
        );
    };

    hasConfirmShipTo = () => {
        return (
            <SettingsRow
                title={"confirm_ship_to"}
                detail={"help_text_confirm_ship_to"}
                name={"has_confirm_ship_to"}
                isActive={!!this.state.supplierModel.has_confirm_ship_to}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    showHolidaySidebar = () => {
        const holidaySidebar = (
            <HolidaysSidebar
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                cancelFn={this.hideSidebar}
            />
        );

        this.props.setSidebarComponent(holidaySidebar);
        this.props.toggleSidebar(true);
    };

    hideSidebar = () => {
        this.props.toggleSidebar(false);
        this.props.setSidebarComponent(null);
    };

    hasHolidays = () => {
        if (this.props.supplierModel.has_service_levels || this.props.supplierModel.has_lead_times) {
            const holidayComponent = (
                <div>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_holidays}
                            name={"has_holidays"}
                            fn={this.handleSupplierChange}
                            label={""}
                            showDisableConfirm={false}
                            disabled={false}
                        />
                        <div>
                            {this.props.supplierModel.has_holidays ? (
                                <OwButton title={"edit_holidays"} fn={this.showHolidaySidebar} leftIconClass={"fad fa-tree-palm"} />
                            ) : null}
                        </div>
                    </div>
                </div>
            );
            return (
                <SettingsRow
                    title={"has_holidays"}
                    detail={"help_text_has_holidays"}
                    name={"has_holidays"}
                    isActive={!!this.state.supplierModel.has_holidays}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                    component={holidayComponent}
                />
            );
        } else {
            return null;
        }
    };

    showServiceLevelsSidebar = () => {
        const serviceLevelsSidebar = (
            <ServiceLevelsSidebar
                supplierModel={this.props.supplierModel}
                userModel={this.props.userModel}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                cancelFn={this.hideSidebar}
            />
        );

        this.props.setSidebarComponent(serviceLevelsSidebar);
        this.props.toggleSidebar(true);
    };

    hasServiceLevels = () => {
        const serviceLevelsComponent = (
            <div>
                <div className={""}>
                    <OwToggle
                        active={!!this.state.supplierModel.has_service_levels}
                        name={"has_service_levels"}
                        fn={this.handleSupplierChange}
                        label={""}
                        showDisableConfirm={false}
                        disabled={false}
                    />
                    <div>
                        {this.props.supplierModel.has_service_levels ? (
                            <OwButton
                                title={"edit_service_levels"}
                                fn={this.showServiceLevelsSidebar}
                                leftIconClass={"fad fa-rabbit-fast"}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"service_levels"}
                detail={"help_text_has_service_levels"}
                name={"has_service_levels"}
                isActive={!!this.state.supplierModel.has_service_levels}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                component={serviceLevelsComponent}
            />
        );
    };

    showBrandedLoginSidebar = () => {
        const component = (
            <BrandedLoginSidebar
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                toggleSidebar={this.hideSidebar}
                notifyFn={this.props.notifyFn}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    brandedLogin = () => {
        const brandedLoginComponent = (
            <div>
                <div className={""}>
                    <div>
                        <OwButton title={"edit_branded_login"} fn={this.showBrandedLoginSidebar} leftIconClass={"fad fa-pencil"} />
                    </div>
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"branded_login"}
                detail={"help_text_branded_login"}
                name={"branded_login"}
                isActive={true}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                component={brandedLoginComponent}
            />
        );
    };

    includeWeekendsInLeadTime = () => {
        if (this.props.supplierModel.has_service_levels || this.props.supplierModel.has_lead_times) {
            return (
                <SettingsRow
                    title={"include_weekends_in_lead_time"}
                    detail={"help_text_include_weekends_in_lead_time"}
                    name={"include_weekends_in_lead_time"}
                    isActive={!!this.state.supplierModel.include_weekends_in_lead_time}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                />
            );
        } else {
            return null;
        }
    };

    hasLeadTimes = () => {
        return (
            <SettingsRow
                title={"lead_times"}
                detail={"help_text_has_lead_times"}
                name={"has_lead_times"}
                isActive={!!this.state.supplierModel.has_lead_times}
                disabled={this.state.supplierModel.has_service_levels}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasEstShipDate = () => {
        if (this.props.supplierModel.has_lead_times) {
            return null;
        }

        return (
            <SettingsRow
                title={"est_ship_date"}
                detail={"help_text_has_est_ship_date"}
                name={"has_est_ship_date"}
                isActive={!!this.state.supplierModel.has_est_ship_date}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasNewReleasesCategory = () => {
        return (
            <SettingsRow
                title={"new_releases_category"}
                detail={"help_text_new_releases_category"}
                name={"has_new_releases_category"}
                isActive={!!this.state.supplierModel.has_new_releases_category}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasWarehouses = () => {
        return (
            <SettingsRow
                title={"warehouses"}
                detail={"help_text_has_warehouses"}
                name={"has_warehouses"}
                isActive={!!this.state.supplierModel.has_warehouses}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    warehouseOptions = () => {
        if (!this.state.supplierModel.has_warehouses) {
            return null;
        }

        return (
            <>
                <SettingsRow
                    title={"allow_accounts_select_warehouse"}
                    detail={"help_text_allow_accounts_select_warehouse"}
                    name={"allow_accounts_select_warehouse"}
                    isActive={!!this.state.supplierModel.allow_accounts_select_warehouse}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                />

                <SettingsRow
                    title={"require_accounts_select_warehouse"}
                    detail={"help_text_require_accounts_select_warehouse"}
                    name={"require_accounts_select_warehouse"}
                    isActive={!!this.state.supplierModel.require_accounts_select_warehouse}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                />

                <SettingsRow
                    title={"only_add_items_from_shipping_warehouse"}
                    detail={"help_text_only_add_items_from_shipping_warehouse"}
                    name={"only_add_items_from_shipping_warehouse"}
                    isActive={!!this.state.supplierModel.only_add_items_from_shipping_warehouse}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                />

                <SettingsRow
                    title={"limit_account_warehouses"}
                    detail={"help_text_limit_account_warehouses"}
                    name={"limit_account_warehouses"}
                    isActive={!!this.state.supplierModel.limit_account_warehouses}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                />
            </>
        );
    };

    sendDailyStatusUpdates = () => {
        let isDisabled = true;

        if (this.state.supplierModel.has_service_levels || this.state.supplierModel.has_lead_times) {
            isDisabled = false;
        }

        return (
            <SettingsRow
                title={"daily_update"}
                detail={"help_text_has_daily_update"}
                name={"has_daily_update"}
                isActive={!!this.state.supplierModel.has_daily_update}
                disabled={isDisabled}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hideInventoryFromVendors = () => {
        return (
            <SettingsRow
                title={"hide_inventory_from_vendors"}
                detail={"help_text_hide_inventory_from_vendors"}
                name={"hide_inventory_from_vendors"}
                isActive={!!this.state.supplierModel.hide_inventory_from_vendors}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    qohAsIcon = () => {
        return (
            <SettingsRow
                title={"qoh_as_icon"}
                detail={"help_text_qoh_as_icon"}
                name={"qoh_as_icon"}
                isActive={!!this.state.supplierModel.qoh_as_icon}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hideInventoryFromSalesReps = () => {
        if (this.props.supplierModel.has_rep_groups) {
            return (
                <SettingsRow
                    title={"hide_inventory_from_sales_reps"}
                    detail={"help_text_hide_inventory_from_sales_reps"}
                    name={"hide_inventory_from_sales_reps"}
                    isActive={!!this.state.supplierModel.hide_inventory_from_sales_reps}
                    toggleFn={this.handleSupplierChange}
                    showDisableConfirm={false}
                />
            );
        } else {
            return null;
        }
    };

    getBulkDefaultShipmentWeight = () => {
        if (!this.props.supplierModel.has_shipments) {
            return null;
        } else {
            const weight = Number(this.state.supplierModel.bulk_shipments_default_weight || 0);

            const component = (
                <div className={"w-15r"}>
                    <OwWeightSelector onChange={this.handleSupplierChange} name={"bulk_shipments_default_weight"} weight={weight} />
                </div>
            );

            return (
                <SettingsRow
                    title={"bulk_shipments_default_weight"}
                    detail={"help_bulk_shipments_default_weight"}
                    name={"bulk_shipments_default_weight"}
                    component={component}
                />
            );
        }
    };

    getShipmentCostMarkup = () => {
        if (!this.props.supplierModel.has_shipments) {
            return null;
        } else {
            const upchargeTypeOptions = [
                { value: PriceUpchargeTypeEnum.FIXED, title: "Fixed" },
                { value: PriceUpchargeTypeEnum.PERCENT, title: "Percent" },
            ];

            const shipmentCostMarkup = (
                <div className={"d-flex"}>
                    <div className={"d-flex"}>
                        <div className={"w-5r me-1"}>
                            <OwInputWrapper
                                name={"shipment_cost_markup"}
                                type={"number"}
                                value={this.state.supplierModel.shipment_cost_markup}
                                fn={this.handleSupplierChange}
                            />
                        </div>
                        <div className={"w-7r"}>
                            <OwSelectOption
                                valueProp={"value"}
                                titleProp={"title"}
                                name={"shipment_cost_price_upcharge_type_id"}
                                options={upchargeTypeOptions}
                                fn={this.handleSupplierChange}
                                selectedOption={this.state.supplierModel}
                                selectedOptionProp={"shipment_cost_price_upcharge_type_id"}
                                showBlankFirst={true}
                            />
                        </div>
                    </div>
                </div>
            );

            return (
                <SettingsRow
                    title={"shipment_cost_markup"}
                    detail={"help_text_shipment_cost_markup"}
                    name={"shipment_cost_markup"}
                    component={shipmentCostMarkup}
                />
            );
        }
    };

    showStateByStateTaxSidebar = () => {
        const component = <StateByStateTaxSidebar closeFn={this.closeSidebar} />;

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    hasSalesTax = () => {
        return (
            <SettingsRow
                title={"sales_tax"}
                detail={"help_text_sales_tax"}
                name={"has_sales_tax"}
                isActive={!!this.state.supplierModel.has_sales_tax}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    stateByStateTaxRate = () => {
        if (this.props.supplierModel.Supplier_Integration.has_taxjar) {
            return null;
        }

        if (!this.props.supplierModel.has_sales_tax) {
            return null;
        }

        const stateByStateTaxComponent = (
            <div>
                <OwButton title={"edit_state_by_state_tax"} fn={this.showStateByStateTaxSidebar} />
            </div>
        );

        return (
            <SettingsRow
                title={"state_by_state_tax"}
                detail={"help_text_state_by_state_tax"}
                name={"state_by_state_tax"}
                component={stateByStateTaxComponent}
            />
        );
    };

    handleSupplierSalesTaxConfigChange = (prop: keyof ISalesTaxConfig, value: boolean) => {
        const salesTaxConfig = this.state.supplierModel.sales_tax_config || {};

        if (prop === "shippingTaxable") {
            salesTaxConfig.shippingTaxable = value;
        }

        if (prop === "allowAdminManualTax") {
            salesTaxConfig.allowAdminManualTax = value;
        }

        if (prop === "allowSalesUserManualTax") {
            salesTaxConfig.allowSalesUserManualTax = value;
        }

        const state = {
            hasModelChange: true,
            supplierModel: {
                ...this.state.supplierModel,
                sales_tax_config: salesTaxConfig,
            },
        };

        this.setState(state);
    };

    allowManualTax = () => {
        if (!this.props.supplierModel.has_sales_tax) {
            return null;
        }

        const allowAdminManualTaxComponent = (
            <OwToggle
                fn={(e: any) => {
                    this.handleSupplierSalesTaxConfigChange("allowAdminManualTax", e.target.value);
                }}
                name={"allow_admin_manual_tax"}
                label={"allow_admin_manual_tax"}
                active={!!this.state.supplierModel.sales_tax_config?.allowAdminManualTax}
                labelOnRight={true}
            />
        );

        const allowSalesUserManualTaxComponent = (
            <OwToggle
                fn={(e: any) => {
                    this.handleSupplierSalesTaxConfigChange("allowSalesUserManualTax", e.target.value);
                }}
                name={"allow_sales_user_manual_tax"}
                label={"allow_sales_user_manual_tax"}
                active={!!this.state.supplierModel.sales_tax_config?.allowSalesUserManualTax}
                labelOnRight={true}
            />
        );

        return (
            <SettingsRow
                title={"allow_manual_tax"}
                detail={"help_text_allow_manual_tax"}
                name={"allow_manual_tax"}
                showDisableConfirm={false}
                component={
                    <div>
                        <div>{allowAdminManualTaxComponent}</div>
                        <div>{allowSalesUserManualTaxComponent}</div>
                    </div>
                }
            />
        );
    };

    includeShippingInTax = () => {
        return (
            <SettingsRow
                title={"shipping_taxable"}
                detail={"help_text_shipping_taxable"}
                name={"shippingTaxable"}
                isActive={!!this.state.supplierModel.sales_tax_config?.shippingTaxable}
                toggleFn={(e: any) => {
                    this.handleSupplierSalesTaxConfigChange("shippingTaxable", e.target.value);
                }}
                showDisableConfirm={false}
            />
        );
    };

    taxRate = () => {
        if (this.props.supplierModel.Supplier_Integration.has_taxjar) {
            return null;
        }

        if (!this.props.supplierModel.has_sales_tax) {
            return null;
        }

        const taxRateComponent = (
            <div>
                <div className={"row mb-2"}>
                    <div className={"col-3"}>
                        <OwInputWrapper
                            fn={this.handleSupplierChange}
                            name={"tax_rate"}
                            value={this.state.supplierModel.tax_rate}
                            appendText={"%"}
                        />
                    </div>
                </div>
                {this.state.supplierModel.sales_tax_config ? (
                    <div>
                        <OwLabel
                            className={"text-warning"}
                            title={"state_tax_rates_override"}
                            leftIconClass={"fad fa-exclamation-triangle"}
                        />
                    </div>
                ) : null}
            </div>
        );

        return <SettingsRow title={"tax_rate"} detail={"help_text_tax_rate"} name={"tax_rate"} component={taxRateComponent} />;
    };

    expeditedLeadTime = () => {
        if (this.props.supplierModel.has_expedited && this.props.supplierModel.has_lead_times) {
            const lead_time_options = [
                { value: "hours", title: "Hour(s)" },
                { value: "days", title: "Day(s)" },
                { value: "months", title: "Month(s)" },
            ];

            const leadTimeComponent = (
                <div className={"d-flex "}>
                    <div className={"me-1"}>
                        <OwInputWrapper
                            className={"form-control-sm text-end"}
                            name={"expedited_shipping_lead_time"}
                            value={this.state.supplierModel.expedited_shipping_lead_time}
                            fn={this.handleSupplierChange}
                            disabled={this.state.supplierModel.has_service_levels}
                        />
                    </div>
                    <div className={""}>
                        <OwSelectOption
                            selectedOption={this.state.supplierModel}
                            selectedOptionProp={"expedited_lead_time_type"}
                            options={lead_time_options}
                            valueProp={"value"}
                            titleProp={"title"}
                            fn={this.handleSupplierChange}
                            name={"expedited_lead_time_type"}
                            isDisabled={this.state.supplierModel.has_service_levels}
                            showBlankFirst={true}
                        />
                    </div>
                </div>
            );

            return (
                <SettingsRow
                    title={"expedited_lead_time"}
                    detail={"help_text_expedited_lead_time"}
                    name={"expedited_shipping_lead_time"}
                    component={leadTimeComponent}
                />
            );
        } else {
            return null;
        }
    };

    toggleShowOrderWorkflow = () => {
        this.setState({
            showOrderWorkflowConfig: !this.state.showOrderWorkflowConfig,
        });
    };

    closeSidebar = () => {
        this.props.toggleSidebar(false);
        this.props.setSidebarComponent(null);
    };

    setDockComponent = (dockComponent: any, dockHeight?: number) => {
        this.setState({
            dockComponent,
            dockHeight: dockHeight || 0.15,
            isDockVisible: true,
        });
    };

    unsetDock = () => {
        this.setState({
            dockComponent: null,
            dockHeight: 0.15,
            isDockVisible: false,
        });
    };

    editWorkflows = () => {
        const workflowSidebar = (
            <WorkflowSidebar
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                setActivityIndicator={this.props.setActivityIndicator}
                closeFn={this.closeSidebar}
                setDockComponent={this.setDockComponent}
                unsetDock={this.unsetDock}
            />
        );

        this.props.setSidebarComponent(workflowSidebar);
        this.props.toggleSidebar(true);
    };

    multiWorkflows = () => {
        const multiWorkflowComponent = (
            <div>
                <div>
                    <OwButton title={"edit_workflows"} fn={this.editWorkflows} />
                </div>
                <div>
                    <OwToggle
                        fn={this.handleSupplierChange}
                        name={"allow_non_admin_select_workflow"}
                        label={"allow_non_admin_select_workflow"}
                        active={!!this.props.supplierModel.allow_non_admin_select_workflow}
                    />
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"multiple_order_workflows"}
                detail={"help_text_multiple_order_workflows"}
                name={"has_multi_workflows"}
                optionClassName={"min-w-17_5r"}
                toggledOnComponent={multiWorkflowComponent}
                isActive={this.props.supplierModel.has_multi_workflows}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    orderWorkflowConfig = () => {
        const orderSteps = OrderEntryService.getOrderSteps(this.props.supplierModel, OrderStatesEnum.PRELIMINARY);

        const lastOrderStep = orderSteps[orderSteps.length - 1];

        const workflowComponent: any = this.props.supplierModel.has_multi_workflows ? (
            <div>
                <OwLabel title={"using_multiple_order_workflow_option"} />
            </div>
        ) : (
            <div className={"orderWorkflowConfigWrapper"}>
                <OrderProgressTracker order={this.state.fakeOrder} orderStateId={lastOrderStep.order_state_id} />
                <div>
                    <div className={"mb-5"}>
                        <ChevronToggle
                            toggleFn={this.toggleShowOrderWorkflow}
                            showChevron={true}
                            isVisible={this.state.showOrderWorkflowConfig}
                        />
                        <OwLabel className={"ms-2"} title={"manage_workflow"} noBottomMargin={true} fn={this.toggleShowOrderWorkflow} />
                    </div>

                    {this.state.showOrderWorkflowConfig ? (
                        <div className={"workflowConfigurator"}>
                            <OrderWorkflowConfigurator
                                userModel={this.props.userModel}
                                supplierModel={this.props.supplierModel}
                                updateFn={this.handleSupplierChange}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        );

        return (
            <SettingsRow
                title={"order_workflow"}
                detail={"help_text_order_workflow"}
                name={"order_progress_states"}
                component={workflowComponent}
                optionClassName={"min-w-17_5r"}
            />
        );
    };

    qtyPrecision = () => {
        const precision_options = [
            { value: 0, title: "0" },
            { value: 1, title: ".1" },
            { value: 2, title: ".01" },
            { value: 3, title: ".001" },
        ];

        const qtyPrecisionComponent = (
            <div className={"d-inline-flex"}>
                <OwSelectOption
                    selectedOption={this.state.supplierModel}
                    selectedOptionProp={"qty_precision"}
                    options={precision_options}
                    valueProp={"value"}
                    titleProp={"title"}
                    fn={this.handleSupplierChange}
                    name={"qty_precision"}
                    showBlankFirst={true}
                />
            </div>
        );

        return (
            <SettingsRow
                title={"qty_precision"}
                detail={"help_text_qty_precision"}
                name={"qty_precision"}
                component={qtyPrecisionComponent}
            />
        );
    };

    pricingPrecision = () => {
        const pricingOptions = [
            { value: 0, title: "0" },
            { value: 1, title: ".1" },
            { value: 2, title: ".01" },
            { value: 3, title: ".001" },
            { value: 4, title: ".0001" },
        ];

        const pricingPrecisionComponent = (
            <div className={"d-inline-flex"}>
                <OwSelectOption
                    selectedOption={this.state.supplierModel}
                    selectedOptionProp={"pricing_precision"}
                    options={pricingOptions}
                    valueProp={"value"}
                    titleProp={"title"}
                    fn={this.handleSupplierChange}
                    name={"pricing_precision"}
                    showBlankFirst={true}
                />
            </div>
        );

        return (
            <SettingsRow
                title={"pricing_precision"}
                detail={"help_text_pricing_precision"}
                name={"pricing_precision"}
                component={pricingPrecisionComponent}
            />
        );
    };

    hasCategoryDiscounts = () => {
        return (
            <SettingsRow
                title={"category_discounts"}
                detail={"help_text_category_discounts"}
                name={"has_category_discounts"}
                isActive={!!this.state.supplierModel.has_category_discounts}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                disabled={!!this.state.supplierModel.has_price_group_category_discounts}
            />
        );
    };

    hasCategoryPriceGroupDiscounts = () => {
        return (
            <SettingsRow
                title={"category_price_group_discounts"}
                detail={"help_text_category_price_group_discounts"}
                name={"has_price_group_category_discounts"}
                isActive={!!this.state.supplierModel.has_price_group_category_discounts}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                disabled={!!this.state.supplierModel.has_category_discounts}
            />
        );
    };

    hasHomeCategories = () => {
        return (
            <SettingsRow
                title={"home_categories"}
                detail={"help_text_home_categories"}
                name={"has_home_categories"}
                isActive={!!this.state.supplierModel.has_home_categories}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    allowMultipleCategories = () => {
        return (
            <SettingsRow
                title={"multiple_item_categories"}
                detail={"help_text_multiple_item_categories"}
                name={"allow_multiple_categories"}
                isActive={!!this.state.supplierModel.allow_multiple_categories}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    belowMinPriceApproval = () => {
        return (
            <SettingsRow
                title={"below_min_price_approval"}
                detail={"help_text_below_min_price_approval"}
                name={"below_min_price_approval"}
                isActive={!!this.state.supplierModel.below_min_price_approval}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasLots = () => {
        const subDetails = (
            <div className={"mt-3"}>
                {this.state.supplierModel.has_pick_list_management ? (
                    <OwToggle
                        label={"assign_lots_in_pick_list"}
                        fn={this.handleSupplierChange}
                        name={"assign_lots_in_pick_list"}
                        active={!!this.state.supplierModel.assign_lots_in_pick_list}
                        labelOnRight={true}
                    />
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"has_lots"}
                detail={"help_text_has_lots"}
                name={"has_lots"}
                isActive={!!this.state.supplierModel.has_lots}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                toggledOnComponent={subDetails}
            />
        );
    };

    hasSerials = () => {
        return (
            <SettingsRow
                title={"has_serials"}
                detail={"help_text_has_serials"}
                name={"has_serials"}
                isActive={!!this.state.supplierModel.has_serials}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasNonInventoryOrders = () => {
        return (
            <SettingsRow
                title={"has_non_inventory_orders"}
                detail={"help_text_has_non_inventory_orders"}
                name={"has_noninventory_orders"}
                isActive={!!this.state.supplierModel.has_noninventory_orders}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasUserDetailOnPackingList = () => {
        return (
            <SettingsRow
                title={"user_detail_on_packing_list"}
                detail={"help_text_user_detail_on_packing_list"}
                name={"has_user_detail_on_packing_list"}
                isActive={!!this.state.supplierModel.has_user_detail_on_packing_list}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    showSubmitOnPackingList = () => {
        return (
            <SettingsRow
                title={"show_submit_on_packing_list"}
                detail={"help_text_show_submit_on_packing_list"}
                name={"show_submit_on_packing_list"}
                isActive={!!this.state.supplierModel.show_submit_on_packing_list}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    sendShipmentEmails = () => {
        return (
            <SettingsRow
                title={"send_shipment_emails"}
                detail={"help_text_send_shipment_emails"}
                name={"send_shipment_emails"}
                isActive={!!this.state.supplierModel.send_shipment_emails}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasTermsOnPackingList = () => {
        return (
            <SettingsRow
                title={"terms_on_packing_list"}
                detail={"help_text_terms_on_packing_list"}
                name={"has_terms_on_packing_list"}
                isActive={!!this.state.supplierModel.has_terms_on_packing_list}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasRepGroups = () => {
        return (
            <SettingsRow
                title={"rep_groups"}
                detail={"help_text_has_rep_groups"}
                name={"has_rep_groups"}
                isActive={!!this.state.supplierModel.has_rep_groups}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasDiscounts = () => {
        const onComponent = (
            <div className={"mt-4"}>
                <OwToggle
                    fn={this.handleSupplierChange}
                    name={"allow_non_admin_discount"}
                    label={"allow_non_admin_discount"}
                    active={!!this.state.supplierModel.allow_non_admin_discount}
                    labelOnRight={true}
                />
            </div>
        );

        return (
            <SettingsRow
                title={"discounts"}
                detail={"help_text_has_discounts"}
                name={"has_discounts"}
                isActive={!!this.state.supplierModel.has_discounts}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                toggledOnComponent={onComponent}
            />
        );
    };

    hasExpirationDates = () => {
        return (
            <SettingsRow
                title={"has_exp_date"}
                detail={"help_text_has_exp_date"}
                name={"has_exp_date"}
                isActive={!!this.state.supplierModel.has_exp_date}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasCartons = () => {
        return (
            <SettingsRow
                title={"has_cartons"}
                detail={"help_text_has_cartons"}
                name={"has_cartons"}
                isActive={!!this.state.supplierModel.has_cartons}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasTakeOffs = () => {
        return (
            <SettingsRow
                title={"take_offs"}
                detail={"help_text_has_take_offs"}
                name={"has_take_offs"}
                isActive={!!this.state.supplierModel.has_take_offs}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    paymentsOnDetailView = () => {
        const defaultPaymentOptions: { name: string; id: PaymentServiceTypeEnum }[] = [];

        if (this.props.supplierModel.Supplier_Integration.has_qbo && this.props.supplierModel.Supplier_Integration.has_qbo_payments) {
            defaultPaymentOptions.push({ name: "QuickBooks Online Payments", id: PaymentServiceTypeEnum.QUICKBOOKS_ONLINE_PAYMENTS });
        }

        if (this.props.supplierModel.Supplier_Integration.has_square) {
            defaultPaymentOptions.push({ name: "Square", id: PaymentServiceTypeEnum.SQUARE });
        }

        if (this.props.supplierModel.Supplier_Integration.has_stripe) {
            defaultPaymentOptions.push({ name: "Stripe", id: PaymentServiceTypeEnum.STRIPE });
        }

        if (this.props.supplierModel.Supplier_Integration.has_authnet) {
            defaultPaymentOptions.push({ name: "Authorize.Net", id: PaymentServiceTypeEnum.AUTHORIZE_NET });
        }

        return (
            <div className={"w-15r mt-3"}>
                {!defaultPaymentOptions.length ? (
                    <div>
                        <OwLabel title={"enable_at_least_one_payment_service_in_business_integrations"} noBottomMargin={true} />
                    </div>
                ) : (
                    <div>
                        <OwLabel title={"payment_service"} />
                        <OwSelectOption
                            titleProp={"name"}
                            valueProp={"id"}
                            options={defaultPaymentOptions}
                            selectedOption={this.state.supplierModel}
                            selectedOptionProp={"default_payment_service_id"}
                            name={"default_payment_service_id"}
                            fn={this.handleSupplierChange}
                            showBlankFirst={true}
                        />
                    </div>
                )}
            </div>
        );
    };

    hasPayments = () => {
        return (
            <SettingsRow
                title={"payments"}
                detail={"help_text_has_payments"}
                name={"has_payments"}
                isActive={!!this.state.supplierModel.has_payments}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
                toggledOnComponent={this.paymentsOnDetailView()}
            />
        );
    };

    hasVendorPriority = () => {
        return (
            <SettingsRow
                title={"account_priority"}
                detail={"help_text_account_priority"}
                name={"has_vendor_priority"}
                isActive={!!this.state.supplierModel.has_vendor_priority}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasBackorders = () => {
        const defaultAllowBackorders = (
            <div className={"d-flex align-items-center"}>
                <OwToggle
                    name={"default_allow_backorders"}
                    fn={this.handleSupplierChange}
                    label={"default_allow_backorders"}
                    active={!!this.state.supplierModel.default_allow_backorders}
                    labelOnRight={true}
                />
                <OwIconTooltip
                    tooltipContent={
                        <div>
                            <OwLabel title={"help_text_default_allow_backorders"} />
                        </div>
                    }
                    iconClassName={"ms-2 fas fa-info-circle"}
                />
            </div>
        );

        const requireSubsBoConfirmation = (
            <div className={"mt-2 d-flex align-items-center"}>
                <OwToggle
                    name={"require_order_subs_bo_confirmation"}
                    fn={this.handleSupplierChange}
                    label={"require_order_subs_bo_confirmation"}
                    active={!!this.state.supplierModel.require_order_subs_bo_confirmation}
                    labelOnRight={true}
                />
                <OwIconTooltip
                    tooltipContent={
                        <div>
                            <OwLabel title={"help_text_require_order_subs_bo_confirmation"} />
                        </div>
                    }
                    iconClassName={"ms-2 fas fa-info-circle"}
                />
            </div>
        );

        const backorderBehaviorDefault = (
            <div className="d-flex align-items-center mt-3">
                <OwLabel title={"default_backorder_behavior"} />
                <div className="ms-2" style={{ width: "250px" }}>
                    <OwSelectOption
                        titleProp={"title"}
                        valueProp={"value"}
                        fn={this.handleSupplierChange}
                        name={"default_backorder_behavior"}
                        options={[
                            {
                                title: "Partial Fill - Allow partial orders, create backorder for remaining",
                                value: BackorderBehaviorEnum.PARTIAL_FILL,
                            },
                            { title: "Full - Create backorder if unable to fully fill", value: BackorderBehaviorEnum.FULL },
                            {
                                title: "Manual - Reserve inventory if possible, user will create backorder manually",
                                value: BackorderBehaviorEnum.MANUAL,
                            },
                        ]}
                        selectedOption={this.state.supplierModel}
                        selectedOptionProp={"default_backorder_behavior"}
                        showBlankFirst={true}
                    />
                </div>
                <OwIconTooltip
                    tooltipContent={
                        <div>
                            <OwLabel title={"tooltip_default_backorder_behavior"} />
                        </div>
                    }
                    iconClassName={"ms-2 fas fa-info-circle"}
                />
            </div>
        );

        const backorderModalVisibility = (
            <div className="mt-2 d-flex align-items-center">
                <OwLabel title={"backorder_modal_visibility"} />
                <div className="ms-2" style={{ width: "250px" }}>
                    <OwSelectOption
                        titleProp={"title"}
                        valueProp={"value"}
                        fn={this.handleSupplierChange}
                        name={"backorder_modal_visibility"}
                        options={[
                            { title: "All Users", value: BackorderModalVisibilityEnum.ALL_USERS },
                            { title: "Internal Users Only", value: BackorderModalVisibilityEnum.INTERNAL_USERS },
                            { title: "Admin Users Only", value: BackorderModalVisibilityEnum.ADMIN_USERS },
                        ]}
                        selectedOption={this.state.supplierModel}
                        selectedOptionProp={"backorder_modal_visibility"}
                        showBlankFirst={true}
                    />
                </div>
                <OwIconTooltip
                    tooltipContent={
                        <div>
                            <OwLabel title={"tooltip_backorder_modal_visibility"} />
                        </div>
                    }
                    iconClassName={"ms-2 fas fa-info-circle"}
                />
            </div>
        );

        const autoHoldForBackorders = (
            <div className="mt-2 d-flex align-items-center">
                <OwToggle
                    name={"auto_hold_for_backorders"}
                    fn={this.handleSupplierChange}
                    label={"auto_hold_for_backorders"}
                    active={!!this.state.supplierModel.auto_hold_for_backorders}
                    labelOnRight={true}
                />
                <OwIconTooltip
                    tooltipContent={
                        <div>
                            <OwLabel title={"tooltip_auto_hold_for_backorders"} />
                        </div>
                    }
                    iconClassName={"ms-2 fas fa-info-circle"}
                />
            </div>
        );

        return (
            <SettingsRow
                title={"backorders"}
                detail={"help_text_has_backorders"}
                name={"has_backorders"}
                isActive={!!this.state.supplierModel.has_backorders}
                toggleFn={this.handleSupplierChange}
                toggledOnComponent={
                    <div>
                        {defaultAllowBackorders}
                        {requireSubsBoConfirmation}
                        {backorderBehaviorDefault}
                        {backorderModalVisibility}
                        {autoHoldForBackorders}
                    </div>
                }
            />
        );
    };

    ordersRequireShipToEntry = () => {
        return (
            <SettingsRow
                title={"orders_require_ship_to_entry"}
                detail={"help_text_orders_require_ship_to_entry"}
                name={"orders_require_ship_to_entry"}
                isActive={!!this.state.supplierModel.orders_require_ship_to_entry}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasPercentageFillable = () => {
        return (
            <SettingsRow
                title={"percent_fillable"}
                detail={"help_text_has_percent_fillable"}
                name={"has_percent_fillable"}
                isActive={!!this.state.supplierModel.has_percent_fillable}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasNoOrderItems = () => {
        return (
            <SettingsRow
                title={"no_order_items"}
                detail={"help_text_has_no_order_items"}
                name={"has_no_order_items"}
                isActive={!!this.state.supplierModel.has_no_order_items}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasOrderCancelDate = () => {
        return (
            <SettingsRow
                title={"order_cancel_date"}
                detail={"help_text_has_order_cancel_date"}
                name={"has_order_cancel_date"}
                isActive={!!this.state.supplierModel.has_order_cancel_date}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasUseMSRPForDefaultPrice = () => {
        return (
            <SettingsRow
                title={"use_msrp_for_default_price"}
                detail={"help_text_use_msrp_for_default_price"}
                name={"use_msrp_for_default_price"}
                isActive={!!this.state.supplierModel.use_msrp_for_default_price}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasStyleColor = () => {
        return (
            <SettingsRow
                title={"has_style_color"}
                detail={"help_text_has_style_color"}
                name={"has_style_color"}
                isActive={!!this.state.supplierModel.has_style_color}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    allowOrderOnHold = () => {
        return (
            <SettingsRow
                title={"allow_orders_on_hold"}
                detail={"help_text_allow_orders_on_hold"}
                name={"allow_orders_on_hold"}
                isActive={!!this.state.supplierModel.allow_orders_on_hold}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasEcommerceView = () => {
        const ecommerceComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_ecommerce_view}
                            name={"has_ecommerce_view"}
                            fn={this.handleSupplierChange}
                            label={""}
                        />
                    </div>
                </div>

                {this.state.supplierModel.has_ecommerce_view ? (
                    <div className={"d-flex flex-column"}>
                        <div className={"mt-3"}>
                            <div>
                                <OwLabel title={"photo_view_default_view"} />
                            </div>
                            <OwToggle
                                active={!!this.state.supplierModel.ecommerce_default_view}
                                name={"ecommerce_default_view"}
                                fn={this.handleSupplierChange}
                                label={""}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"photo_view"}
                detail={"help_text_has_photo_view"}
                name={"has_ecommerce_view"}
                component={ecommerceComponent}
            />
        );
    };

    hasAutoSetInactiveNonPresentBulkUploads = () => {
        return (
            <SettingsRow
                title={"set_inactive_nonpresent_items"}
                detail={"help_text_set_inactive_nonpresent_items"}
                name={"has_auto_inactive_bulk_load"}
                isActive={!!this.state.supplierModel.has_auto_inactive_bulk_load}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasOrderDueDate = () => {
        return (
            <SettingsRow
                title={"order_due_date"}
                detail={"help_text_has_order_due_date"}
                name={"has_order_due_date"}
                isActive={!!this.state.supplierModel.has_order_due_date}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasGoogleMaps = () => {
        return (
            <SettingsRow
                title={"google_maps"}
                detail={"help_text_google_maps"}
                name={"has_google_maps"}
                isActive={!!this.state.supplierModel.has_google_maps}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasInventory = () => {
        return (
            <SettingsRow
                title={"inventory"}
                detail={"help_text_has_inventory"}
                name={"has_inventory"}
                isActive={!!this.state.supplierModel.has_inventory}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    releaseInventoryOnFulfillmentStatus = () => {
        return (
            <SettingsRow
                title={"release_inventory_on_fulfillment_status"}
                detail={"help_text_release_inventory_on_fulfillment_status_short"}
                name={"release_inventory_on_fulfillment_status"}
                isActive={!!this.state.supplierModel.release_inventory_on_fulfillment_status}
                toggleFn={this.handleSupplierChange}
                component={
                    <div>
                        <OwToggle
                            active={!!this.state.supplierModel.release_inventory_on_fulfillment_status}
                            name={"release_inventory_on_fulfillment_status"}
                            fn={this.handleSupplierChange}
                            label={""}
                        />
                        <WhatsThis subject="help_text_release_inventory_on_fulfillment_status" />
                    </div>
                }
            />
        );
    };

    hideBatchFeatures = () => {
        return (
            <SettingsRow
                title={"show_batch_features"}
                detail={"help_text_show_batch_features"}
                name={"show_batch_features"}
                isActive={!!this.state.supplierModel.show_batch_features}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasQtyBreak = () => {
        return (
            <SettingsRow
                title={"has_qty_break"}
                detail={"help_text_has_qty_break"}
                name={"has_qty_break"}
                isActive={!!this.state.supplierModel.has_qty_break}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hasPriceBands = () => {
        return (
            <SettingsRow
                title={"price_bands"}
                detail={"help_text_price_bands"}
                name={"has_price_bands"}
                isActive={!!this.state.supplierModel.has_price_bands}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    disableAccountQuoteOrderEntry = () => {
        return (
            <SettingsRow
                title={"disable_account_quote_order_entry"}
                detail={"help_text_disable_account_quote_order_entry"}
                name={"disable_vendor_quote_order_entry"}
                isActive={!!this.state.supplierModel.disable_vendor_quote_order_entry}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    hideDownloadPDF = () => {
        return (
            <SettingsRow
                title={"show_download_pdf"}
                detail={"help_text_show_download_pdf"}
                name={"show_download_pdf"}
                isActive={!!this.state.supplierModel.show_download_pdf}
                toggleFn={this.handleSupplierChange}
            />
        );
    };

    apiKeys = () => {
        const apiKeysComponent = <ApiKey />;

        return (
            <SettingsRow
                title={"api_keys"}
                detail={"help_text_api_keys"}
                name={"api_keys"}
                toggleFn={() => {}}
                component={apiKeysComponent}
            />
        );
    };

    allowAppLoginSupplierUsers = () => {
        return (
            <SettingsRow
                title={"allow_app_login_supplier_users"}
                detail={"help_text_allow_app_login_supplier_users"}
                name={"allow_app_login_supplier_users"}
                isActive={!!this.state.supplierModel.allow_app_login_supplier_users}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowAppLoginVendorUsers = () => {
        return (
            <SettingsRow
                title={"allow_app_login_accounts"}
                detail={"help_text_allow_app_login_accounts"}
                name={"allow_app_login_vendor_users"}
                isActive={!!this.state.supplierModel.allow_app_login_vendor_users}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    allowAppCreateAccounts = () => {
        return (
            <SettingsRow
                title={"allow_app_create_accounts"}
                detail={"help_text_allow_app_create_accounts"}
                name={"allow_app_create_accounts"}
                isActive={!!this.state.supplierModel.allow_app_create_accounts}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    appDashboardConfig = () => {
        const ViewAppDashboardConfig = () => {
            return (
                <div>
                    <div>
                        <OwButton
                            title={"edit_app_dashboard_config"}
                            fn={() => {
                                this.props.navigate("/business/settings/app-dashboard-config");
                            }}
                            leftIconClass={"fad fa-pencil"}
                        />
                    </div>
                </div>
            );
        };

        return (
            <SettingsRow
                title={"app_dashboard_config"}
                detail={"help_text_app_dashboard_config"}
                name={"app_dashboard_config"}
                isActive={true}
                toggleFn={() => {}}
                component={<ViewAppDashboardConfig />}
            />
        );
    };

    allowNegativeOrderQty = () => {
        return (
            <SettingsRow
                title={"allow_negative_order_qty"}
                detail={"help_text_allow_negative_order_qty"}
                name={"allow_neg_order_qty"}
                isActive={!!this.state.supplierModel.allow_neg_order_qty}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    hasDoNotShipBeforeDate = () => {
        return (
            <SettingsRow
                title={"do_not_ship_before_date"}
                detail={"help_text_has_do_not_ship_before_date"}
                name={"has_do_not_ship_before_date"}
                isActive={!!this.state.supplierModel.has_do_not_ship_before_date}
                toggleFn={this.handleSupplierChange}
                showDisableConfirm={false}
            />
        );
    };

    showOrderCategories = () => {
        const component = (
            <OrderCategoriesSidebar
                setActivityIndicator={this.props.setActivityIndicator}
                notifyFn={this.props.notifyFn}
                socket={this.props.socket}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                cancelFn={this.hideSidebar}
            />
        );

        this.props.setSidebarComponent(component);
        this.props.toggleSidebar(true);
    };

    hasOrderCategories = () => {
        const orderCategoriesComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_order_categories}
                            name={"has_order_categories"}
                            fn={this.handleSupplierChange}
                            label={""}
                        />
                    </div>
                </div>

                {this.state.supplierModel.has_order_categories ? (
                    <div className={"d-flex flex-column"}>
                        <div className={"mt-3"}>
                            <OwButton title={"order_categories"} fn={this.showOrderCategories} leftIconClass={"fad fa-pencil"} />
                        </div>

                        <div className={"mt-3"}>
                            <div>
                                <OwLabel title={"order_category_required"} />
                            </div>
                            <OwToggle
                                active={!!this.state.supplierModel.order_category_required}
                                name={"order_category_required"}
                                fn={this.handleSupplierChange}
                                label={""}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"order_categories"}
                detail={"help_text_has_order_categories"}
                name={"has_order_categories"}
                component={orderCategoriesComponent}
            />
        );
    };

    hasDefaultOrderCatalog = () => {
        const defaultOrderCatalogComponent = (
            <div>
                <div className={"d-flex "}>
                    <div className={""}>
                        <OwToggle
                            active={!!this.state.supplierModel.has_default_order_catalog}
                            name={"has_default_order_catalog"}
                            fn={this.handleSupplierChange}
                            label={""}
                        />
                    </div>
                </div>

                {this.state.supplierModel.has_default_order_catalog ? (
                    <div>
                        <div className={"d-flex flex-column mt-5 mb-5"}>
                            <OwLabel title={"default_catalog"} />
                            <div className={"w-15r"}>
                                <OwSelectOption
                                    titleProp={"name"}
                                    valueProp={"id"}
                                    name={"default_order_catalog_id"}
                                    options={this.state.catalogs}
                                    selectedOption={this.state.supplierModel}
                                    selectedOptionProp={"default_order_catalog_id"}
                                    fn={this.handleSupplierChange}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>
                        <div className={"d-flex flex-column mt-5 mb-5"}>
                            <OwLabel title={"default_price_group"} />
                            <div className={"w-15r"}>
                                <OwSelectOption
                                    titleProp={"value"}
                                    valueProp={"id"}
                                    name={"default_order_price_group_id"}
                                    options={this.state.priceGroups}
                                    selectedOption={this.state.supplierModel}
                                    selectedOptionProp={"default_order_price_group_id"}
                                    fn={this.handleSupplierChange}
                                    showBlankFirst={true}
                                />
                            </div>
                        </div>
                        <div className={"d-flex flex-column mb-5"}>
                            <div>
                                <OwLabel title={"catalog_select_admin_only"} />
                            </div>
                            <OwToggle
                                active={!!this.state.supplierModel.catalog_select_admin_only}
                                name={"catalog_select_admin_only"}
                                fn={this.handleSupplierChange}
                                label={""}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );

        return (
            <SettingsRow
                title={"default_order_catalog"}
                detail={"help_text_has_default_order_catalog"}
                name={"has_default_order_catalog"}
                component={defaultOrderCatalogComponent}
            />
        );
    };

    createOrderComponent = () => {
        return (
            <tr>
                <td className={`text-end`}>
                    <div>
                        <OwLabel title={"create_order_component"} className={"d-inline-flex me-2"} />
                    </div>
                    <div className={"mt-2"}>
                        <OwLabel title={"help_text_create_order_component"} className={"text-muted mt-4"} />
                    </div>
                </td>
                <td>
                    {this.props.supplierModel.create_order_component ? (
                        this.props.supplierModel.create_order_component
                    ) : (
                        <OwLabel title={"default"} noBottomMargin={true} />
                    )}
                </td>
            </tr>
        );
    };

    pickListComponent = () => {
        return (
            <tr>
                <td className={`text-end`}>
                    <div>
                        <OwLabel title={"pick_list_component"} className={"d-inline-flex me-2"} />
                    </div>
                    <div className={"mt-2"}>
                        <OwLabel title={"help_text_pick_list_component"} className={"text-muted mt-4"} />
                    </div>
                </td>
                <td>
                    {this.props.supplierModel.pick_list_component ? (
                        this.props.supplierModel.pick_list_component
                    ) : (
                        <OwLabel title={"default"} noBottomMargin={true} />
                    )}
                </td>
            </tr>
        );
    };

    setTheme = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        const existingSettings: ISupplierSettings = !_.isString(this.props.supplierModel.settings)
            ? this.props.supplierModel.settings
            : { theme: { type: "DARK", allowCustomDark: false, allowCustomLight: false } };

        const supplierModel = this.state.supplierModel;

        supplierModel.settings = {
            ...existingSettings,
            theme: {
                type: value,
                allowCustomDark: existingSettings.theme.allowCustomDark || false,
                allowCustomLight: existingSettings.theme.allowCustomLight || false,
                custom_light: existingSettings.theme.custom_light,
                custom_dark: existingSettings.theme.custom_dark,
                preview_light: existingSettings.theme.preview_light,
                preview_dark: existingSettings.theme.preview_dark,
            },
        };

        this.setState({
            supplierModel,
            updateSupplierState: true,
        });
    };

    handleCustomTheme = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const supplierModel = this.state.supplierModel;

        let settings: ISupplierSettings;

        if (_.isString(supplierModel.settings)) {
            settings = JSON.parse(supplierModel.settings);
        } else {
            settings = supplierModel.settings;
        }

        // @ts-expect-error
        settings.theme[name] = value;

        supplierModel.settings = settings;

        this.setState({ supplierModel });
    };

    doThemePreview = () => {};

    handleThemeChange = (mode: "LIGHT" | "DARK", theme: IThemeVariables, preview: boolean) => {
        let settings: ISupplierSettings;

        if (_.isString(this.state.supplierModel.settings)) {
            settings = JSON.parse(this.state.supplierModel.settings);
        } else {
            settings = this.state.supplierModel.settings;
        }

        if (!preview) {
            if (mode === "LIGHT") {
                settings.theme.custom_light = theme;
            } else {
                settings.theme.custom_dark = theme;
            }
        } else {
            if (mode === "LIGHT") {
                settings.theme.preview_light = theme;
            } else {
                settings.theme.preview_dark = theme;
            }
        }

        const supplierModel = this.state.supplierModel;

        supplierModel.settings = settings;

        this.setState(
            {
                supplierModel,
            },
            () => {
                this.updateSupplierThemeSettings();
            }
        );
    };

    handleSupplierSettingsChange = (e: ChangeEvent<any>, section: "eCommerce", subSection?: string) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const supplierModel = this.state.supplierModel;

        const settings = { ...supplierModel.settings };

        if (!settings.screens) {
            settings.screens = {};
        }

        if (!settings.screens?.[section]) {
            settings.screens[section] = {};
        }

        // @ts-expect-error
        if (!settings.screens?.[section]?.[subSection]) {
            // @ts-expect-error
            settings.screens[section][subSection] = {};
        }

        if (subSection) {
            // @ts-expect-error
            settings.screens[section][subSection][name] = value;
        } else {
            // @ts-expect-error
            settings.screens[section][name] = value;
        }

        this.setState({
            supplierSettings: settings,
            updateSupplierState: true,
            hasSettingsChange: true,
            useV2SettingsSaveFn: true,
        });
    };

    updateBasicThemeDetails = () => {
        const existingSettings: ISupplierSettings = !_.isString(this.state.supplierModel.settings)
            ? this.state.supplierModel.settings
            : { theme: { type: "DARK", allowCustomDark: false, allowCustomLight: false } };

        const payload: IUpdateSupplierSettingsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            // @ts-expect-error
            settings: {
                ...existingSettings,
                theme: {
                    type: existingSettings.theme.type,
                    allowCustomDark: existingSettings.theme.allowCustomDark || false,
                    allowCustomLight: existingSettings.theme.allowCustomLight || false,
                    custom_light: existingSettings.theme.custom_light,
                    custom_dark: existingSettings.theme.custom_dark,
                    preview_light: existingSettings.theme.preview_light,
                    preview_dark: existingSettings.theme.preview_dark,
                },
            },
        };

        this.props.socket.emit(EndpointsEnum.SupplierUpdateSupplierSettings, payload);

        this.setState({
            updateSupplierState: true,
        });
    };

    themeDetails = () => {
        let settings: ISupplierSettings;

        if (_.isString(this.state.supplierModel.settings)) {
            settings = JSON.parse(this.state.supplierModel.settings);
        } else {
            settings = this.state.supplierModel.settings;
        }

        // if there's a settings.theme but no type set
        if (settings?.theme && !settings?.theme?.type) {
            settings.theme.type = "DARK";
        } else {
            if (!settings.theme) {
                settings.theme = {
                    allowCustomDark: false,
                    allowCustomLight: false,
                    type: "DARK",
                };
            }
        }

        // console.log("settings.theme.type", settings.theme);

        const component = (
            <div>
                <div className={"d-flex"}>
                    <div className={"w-10r mb-4"}>
                        <OwSelectOption
                            titleProp={"title"}
                            valueProp={"value"}
                            options={[
                                { title: "Dark", value: "DARK" },
                                { title: "Light", value: "LIGHT" },
                            ]}
                            selectedOption={settings.theme}
                            selectedOptionProp={"type"}
                            name={"themeType"}
                            fn={this.setTheme}
                            emitTarget={true}
                            showBlankFirst={true}
                        />
                    </div>
                    <div className={"ms-2"}>
                        <OwButton title={"save"} fn={this.updateBasicThemeDetails} />
                    </div>
                </div>

                <div className={"d-flex justify-content-between"}>
                    <div className={"col"}>
                        <div>
                            <OwCheckbox
                                name={"allowCustomDark"}
                                label={"custom_dark"}
                                fn={this.handleCustomTheme}
                                checked={settings.theme.allowCustomDark}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                        <div>
                            {settings.theme.allowCustomDark ? (
                                <OwThemeConfigurator
                                    supplierModel={this.props.supplierModel}
                                    themeChangesFn={this.handleThemeChange}
                                    mode={"DARK"}
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className={"col"}>
                        <div>
                            <OwCheckbox
                                name={"allowCustomLight"}
                                label={"custom_light"}
                                fn={this.handleCustomTheme}
                                checked={settings.theme.allowCustomLight}
                                truthyVal={true}
                                falsyVal={false}
                            />
                        </div>
                        <div>
                            {settings.theme.allowCustomLight ? (
                                <OwThemeConfigurator
                                    supplierModel={this.props.supplierModel}
                                    themeChangesFn={this.handleThemeChange}
                                    mode={"LIGHT"}
                                />
                            ) : null}
                        </div>
                    </div>
                    <div className={"col"}>
                        {settings.theme.allowCustomLight || settings.theme.allowCustomDark ? (
                            <div>
                                <OwLabel title={"details"} />

                                <div>
                                    <div>
                                        <OwLabel title={"background"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_background"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"secondary_background"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_secondary_background"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"minor_background"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_minor_background"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"center_background"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_center_background"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"tab_panel_background"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_tab_panel_background"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"table_odd_rows"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_table_odd_rows"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"table_even_rows"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_table_even_rows"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"table_selected_row"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_table_selected_row"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"table_hover_row"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_table_hover_row"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"order_tracker_highlight"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_order_tracker_highlight"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"highlight_color"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_highlight_color"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"highlight_color_text"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_highlight_color_text"} />
                                </div>

                                <div>
                                    <div>
                                        <OwLabel title={"main_text"} isUnderline={true} />
                                    </div>
                                    <OwLabel className={"text-muted"} title={"help_text_main_text"} />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );

        return <SettingsRow title={"default_theme"} detail={"help_text_theme"} name={"theme"} component={component} />;
    };

    toggleDock = () => {
        const isDockVisible = !this.state.isDockVisible;
        let dockComponent = this.state.dockComponent;
        let dockHeight = this.state.dockHeight;

        if (!isDockVisible) {
            dockComponent = null;
            dockHeight = 0.45;
        }

        this.setState({
            isDockVisible,
            dockComponent,
            dockHeight,
        });
    };

    jumpTo = (id: string) => {
        const elem = document.getElementById(id);
        const mainView = document.getElementById("mainView");

        if (elem && mainView) {
            mainView!.scrollTop = elem.offsetTop - 64;
        }
    };

    render() {
        let tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            tableClass = "";
        }

        const costPricingAdminOnly = this.costPricingAdminOnly();

        /**
         * General
         */
        const themeDetails = this.themeDetails();
        const loginNotification = this.loginNotification(tableClass);
        const disableVendorOrderEntry = this.disableVendorOrderEntry();
        const hasWhiteLabel = this.hasWhiteLabel();
        const docLogo = this.docLogoDetail();
        const brandedLogin = this.brandedLogin();
        const tokenEmails = this.tokenEmails();
        const coopAdvertisementRow = this.coopAdvertisment();
        const hasProjects = this.hasProjects();
        const hasExports = this.hasExports();
        const hasCustomImports = this.hasCustomImports();
        const hasPayments = this.hasPayments();
        const hasGoogleMaps = this.hasGoogleMaps();
        // const showOfflineToggleInHeader = this.showOfflineToggleInHeader();
        const qtyPrecision = this.qtyPrecision();
        const pricingPrecision = this.pricingPrecision();
        const allowAppLoginSupplierUsers = this.allowAppLoginSupplierUsers();
        const allowAppLoginVendorUsers = this.allowAppLoginVendorUsers();
        const allowAppCreateAccounts = this.allowAppCreateAccounts();
        const appDashboardConfig = this.appDashboardConfig();
        const hideBatchFeatures = this.hideBatchFeatures();
        const apiKeys = this.apiKeys();
        const getNoIncrementDetails = this.getNoIncrementDetails();
        const screenOptions = this.getScreenOptions();

        /**
         * Accounts
         */
        const vendorNameOverride = this.getVendorNameOverride();
        const allowCreateVendorInCreateOrder = this.allowCreateVendorInCreateOrder();
        const hasPriceGroupRestrictions = this.hasPriceGroupRestrictions();
        const sendVendorEmails = this.sendVendorEmails();
        const hideVendorPriceGroupSelect = this.hideVendorPriceGroupSelect();
        const hasContacts = this.hasContacts();
        const disableJoinCode = this.disableJoinCode();
        const allowSalesRepsCreateAccounts = this.allowSalesRepsCreateAccounts();
        const hasConfirmShipTo = this.hasConfirmShipTo();
        const hasRepGroups = this.hasRepGroups();
        const hasVendorPriority = this.hasVendorPriority();
        const accountOnlyViewUserOrders = this.accountOnlyViewUserOrders();
        const accountCreditLimits = this.accountCreditLimits();
        const stateLicenseField = this.stateLicenseField();
        const currencies = this.hasCurrencies();
        const defaultNewAccountCatalogAndPriceGroup = this.defaultNewAccountCatalogAndPriceGroup();

        /**
         * Orders
         */
        const createOrderComponent = this.createOrderComponent();
        const orderQtyDefaultStartingNumber = this.orderQtyDefaultStartingNumber();
        const hasEcommerceView = this.hasEcommerceView();
        const hasSalesTax = this.hasSalesTax();
        const taxRate = this.taxRate();
        const stateByStateTax = this.stateByStateTaxRate();
        const includeShippingInTax = this.includeShippingInTax();
        const allowManualTax = this.allowManualTax();
        const hasAddressValidation = this.addressValidations();
        const allowBackToPrelim = this.allowBackToPrelim();
        const redirectOnSubmit = this.redirectOnSubmit();
        const multiWorkflows = this.multiWorkflows();
        const orderWorkflowConfig = this.orderWorkflowConfig();
        const hasOrderCategories = this.hasOrderCategories();
        const hasDefaultOrderCatalog = this.hasDefaultOrderCatalog();
        const sendDailyStatusUpdates = this.sendDailyStatusUpdates();
        const hasServiceLevels = this.hasServiceLevels();
        const hasHolidays = this.hasHolidays();
        const includeWeekendsInLeadTime = this.includeWeekendsInLeadTime();
        const hasEstShipDate = this.hasEstShipDate();
        const hasLeadTimes = this.hasLeadTimes();
        const leadTimeRow = this.leadTime();
        const hasExpedited = this.hasExpedited();
        const expeditedLeadTime = this.expeditedLeadTime();
        const hasConsignment = this.hasConsignment();
        const hasRemakes = this.hasRemakes();
        const hasReorders = this.hasReorders();
        const hasCubes = this.hasCubes();
        const hasSampleOrders = this.hasSampleOrders();
        const hasQuotes = this.hasQuotes();
        const hasQuoteExpDate = this.hasQuoteExpDate();
        const closeQuotesOnConvert = this.closeQuotesOnConvert();
        const requirePoOnConvertToQuote = this.requirePoOnConvertToQuote();
        const disableAccountQuoteOrderEntry = this.disableAccountQuoteOrderEntry();
        const hasHidePricing = this.hasHidePricing();
        const hasCsvOrderEntry = this.hasCsvOrderEntry();
        const allowClients = this.allowClients();
        const allowEditAfterConfirm = this.allowEditAfterConfirm();
        const allowManualPricing = this.allowManualPricing();
        const allowNonAdminManualPricing = this.allowNonAdminManualPricing();
        const hasCostPricing = this.hasCostPricing();
        const noDuplicateOrderItems = this.noDuplicateOrderItems();
        const hasPriceAdjustments = this.hasPriceAdjustments();
        const hasPricingFormulas = this.hasPricingFormulas();
        const allowSalesUsersToEditPricing = this.allowSalesUsersToEditPricing();
        const hasPricingDescriptions = this.hasPricingDescriptions();
        const hasLaborFee = this.hasLaborFee();
        const hasShippingFee = this.hasShippingFee();
        const hasDiscounts = this.hasDiscounts();
        const hasThirdPartyOrderRef = this.hasThirdPartyOrderRef();
        const hideCatalogViewer = this.hideCatalogViewer();
        const hideCategoryViewer = this.hideCategoryViewer();
        const hasTakeOffs = this.hasTakeOffs();
        const hasPercentageFillable = this.hasPercentageFillable();
        const hasNoOrderItems = this.hasNoOrderItems();
        const hasOrderCancelDate = this.hasOrderCancelDate();
        const allowOrdersOnHold = this.allowOrderOnHold();
        const hasOrderBonus = this.hasOrderBonus();
        const hasSpecDueDate = this.hasSpecDueDate();
        const hasOrderEntryScanMode = this.hasOrderEntryScanMode();
        const ordersRequirePO = this.ordersRequirePO();
        const hasOrderDueDate = this.hasOrderDueDate();
        const hasDoNotShipBeforeDate = this.hasDoNotShipBeforeDate();
        const hasCommissions = this.hasCommissions();
        const hideDownloadPDF = this.hideDownloadPDF();
        const allowNegativeOrderQty = this.allowNegativeOrderQty();
        const hasAutomation = this.hasAutomation();
        const ordersRequireShipToEntry = this.ordersRequireShipToEntry();
        const hasTemplates = this.hasTemplates();
        const templateHomeItems = this.templateHomeItems();
        const autoRemoveZeroQtyLineItems = this.autoRemoveZeroQtyLineItems();
        const ordersStartInEditMode = this.ordersStartInEditMode();
        const quoteFooter = this.getQuoteFooter();
        const salesOrderFooter = this.getSalesOrderFooter();
        const invoiceFooter = this.getInvoiceFooter();
        const belowMinPriceApproval = this.belowMinPriceApproval();
        const productGroupComponent = this.productGroupComponent();
        const showFilterProductGroupsOrderEntry = this.showFilterProductGroupsOrderEntry();
        const hasDropshipping = this.hasDropshipping();
        const showOrderShipToFlags = this.showOrderShipToFlags();
        const hideOrderDetailInfo = this.hideOrderDetailInfo();
        const creditCardSurcharge = this.creditCardSurcharge();
        const ecommerceListingPages = this.ecommerceListingPages();
        const ecommerceShowQtyOnHandOnCard = this.ecommerceShowQtyOnHandOnCard();
        const ecommerceAllowEditOrderDetails = this.ecommerceAllowEditOrderDetails();
        const showTotalOrderWeight = this.showTotalOrderWeight();
        const persistItemOptionSelection = this.persistItemOptionSelection();
        const ecommerceCardView = this.ecommerceCardView();
        const rmaModule = this.rmaModule();

        /**
         * Catalogs
         */
        const hasProductSources = this.hasProductSources();
        const hideCategoryAttributes = this.hideCategoryAttributes();
        const hasDimensions = this.hasDimensions();
        const showCommonItemsModal = this.showCommonItemsModal();
        const itemNameDupeCheck = this.itemNameDupeCheck();
        const hasNewReleasesCategory = this.hasNewReleasesCategory();
        const hasCategoryDiscounts = this.hasCategoryDiscounts();
        const hasCategoryPriceGroupDiscounts = this.hasCategoryPriceGroupDiscounts();
        const hasHomeCategories = this.hasHomeCategories();
        const allowMultipleCategories = this.allowMultipleCategories();
        const hasUseMSRPForDefaultPrice = this.hasUseMSRPForDefaultPrice();
        const hasStyleColor = this.hasStyleColor();
        const hasAutoSetInactiveNonPresentBulkUploads = this.hasAutoSetInactiveNonPresentBulkUploads();
        const hasQtyBreak = this.hasQtyBreak();
        const hasPriceBands = this.hasPriceBands();
        const hasCatalogEmail = this.hasCatalogEmail();
        const hasDeliveryEta = this.hasDeliveryEta();
        const hasChildItems = this.hasChildItems();
        const hasMap = this.hasMap();
        const hasUomSets = this.hasUomSets();
        const allowManualUomBaseQty = this.allowManualUomBaseQty();
        const hideUomBaseQty = this.hideUomBaseQty();
        const hasRatioItems = this.hasRatioItems();
        const hasCustomUom = this.hasCustomUom();
        const hasCatchWeights = this.hasCatchWeights();
        const allowItemPriceGroupOverride = this.allowItemPriceGroupOverride();
        const allowFreeEntryItem = this.allowFreeEntryItem();
        const hasApproveDecline = this.hasApproveDecline();
        const allowCreateItemInOrderEntry = this.allowCreateItemInOrderEntry();
        const sumToSingleItem = this.sumToSingleItem();
        const hasCategoryTally = this.hasCategoryTally();

        /**
         * Inventory
         */
        const hasInventory = this.hasInventory();
        const releaseInventoryOnFulfillmentStatus = this.releaseInventoryOnFulfillmentStatus();
        const hasBackorders = this.hasBackorders();
        const notifyMinQty = this.getNotifyMinQty();
        const hideWhenMinQtyOnHand = this.hideWhenMinQtyOnHand();
        const hasPricingOnInventory = this.hasPricingOnInventory();
        const inventoryScreenReadOnly = this.inventoryScreenReadOnly();
        const hasPurchaseOrders = this.hasPurchaseOrders();
        const promptCreatePo = this.promptCreatePo();
        const showPoStatusOnOrderScreen = this.showPoStatusOnOrderScreen();
        const purchaseOrderDupeItemCheck = this.purchaseOrderDupeItemCheck();
        const hasBom = this.hasBom();
        const allowInventoryScreenOrder = this.allowInventoryScreenOrder();
        const hideInventoryFromVendors = this.hideInventoryFromVendors();
        const hideInventoryFromSalesReps = this.hideInventoryFromSalesReps();
        const hasWarehouses = this.hasWarehouses();
        const warehouseOptions = this.warehouseOptions();
        const hasLots = this.hasLots();
        const hasExpirationDates = this.hasExpirationDates();
        const hasSerials = this.hasSerials();
        const hasNonInventoryOrders = this.hasNonInventoryOrders();
        const qohAsIcon = this.qohAsIcon();

        /**
         * Fulfillment
         */
        const hasShipments = this.hasShipments();
        const shippingDefaultCharge = this.shippingDefaultCharge();
        const hasShippingByWeight = this.hasShippingByWeight();
        const hasShippingByOrderTotal = this.hasShippingByOrderTotal();
        const passThroughShippingCosts = this.passThroughShippingCosts();
        const shippingCarriers = this.shippingCarriers();
        const defaultFreightPolicy = this.defaultFreightPolicy();
        const pickListComponent = this.pickListComponent();
        const hasPickListManagement = this.hasPickListManagement();
        const onePackingListPerPickList = this.onPackingListPerPickList();
        const pickListScanMode = this.pickListScanMode();
        const hasPickListRowSteps = this.hasPickListRowSteps();
        const oneOrderPerPickList = this.oneOrderPerPickList();
        const hasCartons = this.hasCartons();
        const hasBillOfLading = this.hasBillOfLading();
        const hasLocalDelivery = this.hasLocalDelivery();
        const hasLocalPickup = this.hasLocalPickup();
        const hasRoutes = this.hasRoutes();
        const hasVehicles = this.hasVehicles();
        const hasDailyRoutesApp = this.hasDailyRoutesApp();
        const shipmentCostMarkup = this.getShipmentCostMarkup();
        const bulkDefaultShipmentWeight = this.getBulkDefaultShipmentWeight();
        const hasTermsOnPackingList = this.hasTermsOnPackingList();
        const hasUserDetailOnPackingList = this.hasUserDetailOnPackingList();
        const showSubmitOnPackingList = this.showSubmitOnPackingList();
        const sendShipmentEmails = this.sendShipmentEmails();

        /**
         * Analysis
         */
        const hasForecast = this.hasForecast();
        const hasAnalytics = this.hasAnalytics();

        const customSettings = this.props.supplierModel.custom_settings ? (
            <OwLabel
                key={"custom_settings"}
                leftIconClass={"fad fa-sparkles"}
                title={"custom_settings"}
                noBottomMargin={true}
                fn={() => {
                    this.jumpTo("CustomSettings");
                }}
            />
        ) : null;

        const controlBarSections = [
            {
                name: "general",
                elements: [
                    <OwLabel
                        key={"general"}
                        leftIconClass={"fad fa-cogs"}
                        title={"general"}
                        noBottomMargin={true}
                        fn={() => {
                            this.jumpTo("General");
                        }}
                    />,
                ],
            },
            {
                name: "accounts",
                elements: [
                    <OwLabel
                        key={"accounts"}
                        leftIconClass={"fad fa-users"}
                        title={"accounts"}
                        noBottomMargin={true}
                        fn={() => {
                            this.jumpTo("Accounts");
                        }}
                    />,
                ],
            },
            {
                name: "orders",
                elements: [
                    <OwLabel
                        key={"orders"}
                        leftIconClass={"fad fa-list-alt"}
                        title={"orders"}
                        noBottomMargin={true}
                        fn={() => {
                            this.jumpTo("Orders");
                        }}
                    />,
                ],
            },
            {
                name: "catalogs",
                elements: [
                    <OwLabel
                        key={"catalogs"}
                        leftIconClass={"fad fa-books"}
                        title={"catalogs"}
                        noBottomMargin={true}
                        fn={() => {
                            this.jumpTo("Catalogs");
                        }}
                    />,
                ],
            },
            {
                name: "inventory",
                elements: [
                    <OwLabel
                        key={"inventory"}
                        leftIconClass={"fad fa-cubes"}
                        title={"inventory"}
                        noBottomMargin={true}
                        fn={() => {
                            this.jumpTo("Inventory");
                        }}
                    />,
                ],
            },
            {
                name: "fulfillment",
                elements: [
                    <OwLabel
                        key={"fulfillment"}
                        leftIconClass={"fad fa-truck"}
                        title={"fulfillment"}
                        noBottomMargin={true}
                        fn={() => {
                            this.jumpTo("Fulfillment");
                        }}
                    />,
                ],
            },
            {
                name: "analysis",
                elements: [
                    <OwLabel
                        key={"analysis"}
                        leftIconClass={"fad fa-analytics"}
                        title={"analysis"}
                        noBottomMargin={true}
                        fn={() => {
                            this.jumpTo("Analysis");
                        }}
                    />,
                ],
            },
        ];

        if (customSettings) {
            controlBarSections.push({
                name: "custom_settings",
                elements: [customSettings],
            });
        }

        /**
         * Custom Settings
         */

        return (
            <div className="SupplierProfileOptions">
                <a id={"top"}></a>
                <div className="row">
                    <div className="col-12 d-flex align-items-center">
                        <OwTitle title={"business_settings"} leftIconName={"fad fa-cog"} />
                        <div className="ms-4">
                            <OwButton
                                disabled={this.state.activeSaveBtn}
                                active={this.state.activeSaveBtn}
                                className={"btn-primary me-2"}
                                title={"save"}
                                leftIconClass={"fas fa-save"}
                                fn={this.save}
                            />
                            {this.state.hasSettingsChange || this.state.hasModelChange ? (
                                <OwLabel
                                    className={"ms-2 text-warning"}
                                    leftIconClass={"fa fa-exclamation-triangle"}
                                    title={"pending_changes"}
                                />
                            ) : null}
                        </div>
                    </div>
                </div>

                <div className={"mt-4 text-center jumpToLinks"}>
                    <ControlBar sections={controlBarSections} />
                </div>

                <OwTitle title={"general"} leftIconName={"fad fa-cogs"} className={"mt-4"} id={"General"} />
                <div className={"table-responsive"}>
                    <table className={"table mt-2 col-12 " + tableClass}>
                        <tbody>
                            {themeDetails}
                            {loginNotification}
                            {disableVendorOrderEntry}
                            {hasWhiteLabel}
                            {docLogo}
                            {brandedLogin}
                            {tokenEmails}
                            {coopAdvertisementRow}
                            {hasProjects}
                            {hasExports}
                            {hasCustomImports}
                            {hasPayments}
                            {hasGoogleMaps}
                            {qtyPrecision}
                            {pricingPrecision}
                            {allowAppLoginSupplierUsers}
                            {allowAppLoginVendorUsers}
                            {allowAppCreateAccounts}
                            {appDashboardConfig}
                            {hideBatchFeatures}
                            {apiKeys}
                            {getNoIncrementDetails}
                            {screenOptions}
                        </tbody>
                    </table>
                </div>

                <OwTitle title={"accounts"} className={"mt-4"} leftIconName={"fad fa-users"} id={"Accounts"} />
                <div className={"table-responsive"}>
                    <table className={"table mt-2 col-12 " + tableClass}>
                        <tbody>
                            {vendorNameOverride}
                            {allowCreateVendorInCreateOrder}
                            {hasPriceGroupRestrictions}
                            {sendVendorEmails}
                            {hideVendorPriceGroupSelect}
                            {hasContacts}
                            {disableJoinCode}
                            {allowSalesRepsCreateAccounts}
                            {hasConfirmShipTo}
                            {hasRepGroups}
                            {hasVendorPriority}
                            {accountOnlyViewUserOrders}
                            {accountCreditLimits}
                            {stateLicenseField}
                            {currencies}
                            {defaultNewAccountCatalogAndPriceGroup}
                        </tbody>
                    </table>
                </div>

                <OwTitle title={"orders"} className={"mt-4"} leftIconName={"fad fa-list-alt"} id={"Orders"} />
                <div className={"table-responsive"}>
                    <table className={"table mt-2 col-12 " + tableClass}>
                        <tbody>
                            {createOrderComponent}
                            {/*{orderQtyDefaultStartingNumber}*/}
                            {hasEcommerceView}
                            {hasSalesTax}
                            {taxRate}
                            {stateByStateTax}
                            {includeShippingInTax}
                            {allowManualTax}
                            {hasAddressValidation}
                            {allowBackToPrelim}
                            {redirectOnSubmit}
                            {multiWorkflows}
                            {orderWorkflowConfig}
                            {hasOrderCategories}
                            {hasDefaultOrderCatalog}
                            {sendDailyStatusUpdates}
                            {hasServiceLevels}
                            {hasHolidays}
                            {includeWeekendsInLeadTime}
                            {hasEstShipDate}
                            {hasLeadTimes}
                            {leadTimeRow}
                            {hasExpedited}
                            {expeditedLeadTime}
                            {hasConsignment}
                            {hasRemakes}
                            {hasReorders}
                            {hasCubes}
                            {hasSampleOrders}
                            {hasQuotes}
                            {hasQuoteExpDate}
                            {closeQuotesOnConvert}
                            {requirePoOnConvertToQuote}
                            {disableAccountQuoteOrderEntry}
                            {hasHidePricing}
                            {hasCsvOrderEntry}
                            {allowClients}
                            {allowEditAfterConfirm}
                            {allowManualPricing}
                            {allowNonAdminManualPricing}
                            {hasCostPricing}
                            {noDuplicateOrderItems}
                            {hasPriceAdjustments}
                            {hasPricingFormulas}
                            {allowSalesUsersToEditPricing}
                            {hasPricingDescriptions}
                            {hasLaborFee}
                            {hasShippingFee}
                            {hasDiscounts}
                            {hasThirdPartyOrderRef}
                            {hideCatalogViewer}
                            {hideCategoryViewer}
                            {hasTakeOffs}
                            {hasPercentageFillable}
                            {hasNoOrderItems}
                            {hasOrderCancelDate}
                            {allowOrdersOnHold}
                            {hasOrderBonus}
                            {hasSpecDueDate}
                            {hasOrderEntryScanMode}
                            {ordersRequirePO}
                            {hasOrderDueDate}
                            {hasDoNotShipBeforeDate}
                            {hasCommissions}
                            {hideDownloadPDF}
                            {allowNegativeOrderQty}
                            {hasAutomation}
                            {ordersRequireShipToEntry}
                            {hasTemplates}
                            {templateHomeItems}
                            {autoRemoveZeroQtyLineItems}
                            {ordersStartInEditMode}
                            {quoteFooter}
                            {salesOrderFooter}
                            {invoiceFooter}
                            {belowMinPriceApproval}
                            {/* {productGroupComponent} */}
                            {showFilterProductGroupsOrderEntry}
                            {hasDropshipping}
                            {showOrderShipToFlags}
                            {hideOrderDetailInfo}
                            {creditCardSurcharge}
                            {allowItemPriceGroupOverride}
                            {hasApproveDecline}
                            {showTotalOrderWeight}
                            {persistItemOptionSelection}
                            {ecommerceCardView}
                            {ecommerceListingPages}
                            {ecommerceShowQtyOnHandOnCard}
                            {ecommerceAllowEditOrderDetails}
                            {rmaModule}
                        </tbody>
                    </table>
                </div>

                <OwTitle title={"catalogs"} className={"mt-4"} leftIconName={"fad fa-books"} id={"Catalogs"} />
                <div className={"table-responsive"}>
                    <table className={"table mt-2 col-12 " + tableClass}>
                        <tbody>
                            {hasProductSources}
                            {hideCategoryAttributes}
                            {hasHomeCategories}
                            {allowMultipleCategories}
                            {hasDimensions}
                            {showCommonItemsModal}
                            {itemNameDupeCheck}
                            {hasNewReleasesCategory}
                            {hasCategoryDiscounts}
                            {hasCategoryPriceGroupDiscounts}
                            {hasCategoryTally}
                            {hasUseMSRPForDefaultPrice}
                            {hasStyleColor}
                            {hasAutoSetInactiveNonPresentBulkUploads}
                            {hasQtyBreak}
                            {hasPriceBands}
                            {hasCatalogEmail}
                            {hasDeliveryEta}
                            {hasChildItems}
                            {hasMap}
                            {hasUomSets}
                            {allowManualUomBaseQty}
                            {hideUomBaseQty}
                            {hasRatioItems}
                            {/*{hasCustomUom}*/}
                            {hasCatchWeights}
                            {allowFreeEntryItem}
                            {allowCreateItemInOrderEntry}
                            {sumToSingleItem}
                        </tbody>
                    </table>
                </div>

                <OwTitle title={"inventory"} className={"mt-4"} leftIconName={"fad fa-cubes"} id={"Inventory"} />
                <div className={"table-responsive"}>
                    <table className={"table mt-2 col-12 " + tableClass}>
                        <tbody>
                            {hasInventory}
                            {releaseInventoryOnFulfillmentStatus}
                            {hasBackorders}
                            {notifyMinQty}
                            {hideWhenMinQtyOnHand}
                            {hasPricingOnInventory}
                            {inventoryScreenReadOnly}
                            {hasPurchaseOrders}
                            {promptCreatePo}
                            {showPoStatusOnOrderScreen}
                            {purchaseOrderDupeItemCheck}
                            {hasBom}
                            {allowInventoryScreenOrder}
                            {hideInventoryFromVendors}
                            {hideInventoryFromSalesReps}
                            {qohAsIcon}
                            {hasWarehouses}
                            {warehouseOptions}
                            {hasLots}
                            {hasExpirationDates}
                            {hasSerials}
                            {hasNonInventoryOrders}
                        </tbody>
                    </table>
                </div>

                <OwTitle title={"fulfillment"} className={"mt-4"} leftIconName={"fad fa-truck"} id={"Fulfillment"} />
                <div className={"table-responsive"}>
                    <table className={"table mt-2 col-12 " + tableClass}>
                        <tbody>
                            {hasShipments}
                            {shippingDefaultCharge}
                            {hasShippingByWeight}
                            {hasShippingByOrderTotal}
                            {passThroughShippingCosts}
                            {shippingCarriers}
                            {sendShipmentEmails}
                            {defaultFreightPolicy}
                            {pickListComponent}
                            {hasPickListManagement}
                            {onePackingListPerPickList}
                            {pickListScanMode}
                            {hasPickListRowSteps}
                            {oneOrderPerPickList}
                            {hasCartons}
                            {hasBillOfLading}
                            {hasLocalDelivery}
                            {hasLocalPickup}
                            {hasRoutes}
                            {hasVehicles}
                            {hasDailyRoutesApp}
                            {shipmentCostMarkup}
                            {bulkDefaultShipmentWeight}
                            {hasTermsOnPackingList}
                            {hasUserDetailOnPackingList}
                            {showSubmitOnPackingList}
                        </tbody>
                    </table>
                </div>

                <OwTitle title={"analysis"} className={"mt-4"} tag={"h3"} leftIconName={"fad fa-analytics"} id={"Analysis"} />
                <div className={"table-responsive"}>
                    <table className={"table mt-2 col-12 " + tableClass}>
                        <tbody>
                            {/*{hasForecast}*/}
                            {hasAnalytics}
                        </tbody>
                    </table>
                </div>

                {this.props.supplierModel.custom_settings ? (
                    <div>
                        <OwTitle
                            title={"custom_settings"}
                            className={"mt-4"}
                            tag={"h3"}
                            leftIconName={"fad fa-sparkles"}
                            id={"CustomSettings"}
                        />
                        <div className={"table-responsive"}>
                            <table className={"table mt-2 col-12 " + tableClass}>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                ) : null}

                <OwBackToTop hasChangesBar={this.state.hasSettingsChange || this.state.hasModelChange} />

                <PendingChangesBar
                    saveActive={this.state.activeSaveBtn}
                    saveFn={this.save}
                    visible={this.state.hasSettingsChange || this.state.hasModelChange}
                />

                <Dock
                    size={this.state.dockHeight}
                    dockStyle={{ background: "var(--main-bg-color)", color: "var(--main-text-color)" }}
                    position="bottom"
                    isVisible={this.state.isDockVisible}>
                    {" "}
                    <div className={"p-2"}>
                        <div className="text-end">
                            <OwButton centerIconClass={"fas fa-times"} fn={this.toggleDock} className={"btn-danger"} />
                        </div>

                        <div className="">{this.state.dockComponent}</div>
                    </div>
                </Dock>
            </div>
        );
    }
}

export default SupplierProfileOptions;
